
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("a5txT", function(module, exports) {

var $7xVCs = parcelRequire("7xVCs");

const $82982cff56793d8b$var$standalonePageTreeStateUpdater = new (0, $7xVCs.PageTreeStateUpdater)();
const $82982cff56793d8b$export$19e3952b1a66ecb = ()=>$82982cff56793d8b$var$standalonePageTreeStateUpdater;
module.exports["getStandalonePageTreeStateUpdater"] = $82982cff56793d8b$export$19e3952b1a66ecb;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("30qWc", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $308Wd = parcelRequire("308Wd");

const $9acca7871dfd8a5c$export$a59d7e865b63a081 = (0, $3u0dr.isReactCompilerActiveV2)() ? function MutationInterop(t0) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let mutation;
    let props;
    if ($[0] !== t0) {
        ({ children: children, mutation: mutation, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = mutation;
        $[3] = props;
    } else {
        children = $[1];
        mutation = $[2];
        props = $[3];
    }
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    let t1;
    if ($[4] !== children || $[5] !== mutate || $[6] !== result) {
        t1 = children(mutate, result);
        $[4] = children;
        $[5] = mutate;
        $[6] = result;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function MutationInterop({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
};
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("b1HmN", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ishvT",
    name: "LoadableChangeEditionNotificationDialog",
    loader: async ()=>(await (parcelRequire("kHp2S"))).ChangeEditionNotificationDialog
});
module.exports["LoadableChangeEditionNotificationDialog"] = $80716d6d5be0d4f0$export$fff6e0d8ba6c4cc6;

});

parcelRegister("kHp2S", function(module, exports) {

let $f11b404c5fa8cafa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f11b404c5fa8cafa$var$load("hhss7"),
    $f11b404c5fa8cafa$var$load("kSVGa")
]).then(()=>parcelRequire('5BDEU'));

});

parcelRegister("hDG7z", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gz8ZY = parcelRequire("gz8ZY");


var $cgEsw = parcelRequire("cgEsw");


var $jbuqY = parcelRequire("jbuqY");

const $c8aadc7c03a52230$export$6d1402fb58384e4f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t0;
    if ($[0] !== isNav4Enabled || $[1] !== props) {
        t0 = isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgEsw.Nav4Layout), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbuqY.Nav3Layout), props);
        $[0] = isNav4Enabled;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["PageLayout"] = $c8aadc7c03a52230$export$6d1402fb58384e4f;

});

parcelRegister("cgEsw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $acf3be568142fa4d$export$25b68ac96f2af713 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Y6119",
    name: "Nav4Layout",
    loader: async ()=>(await (parcelRequire("fLp6f"))).PageLayout
});
module.exports["Nav4Layout"] = $acf3be568142fa4d$export$25b68ac96f2af713;

});

parcelRegister("fLp6f", function(module, exports) {

let $b79eb7115a8fa21b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b79eb7115a8fa21b$var$load("fGTig"),
    $b79eb7115a8fa21b$var$load("6sGtZ"),
    $b79eb7115a8fa21b$var$load("63cQP"),
    $b79eb7115a8fa21b$var$load("b0eph"),
    $b79eb7115a8fa21b$var$load("3QIea"),
    $b79eb7115a8fa21b$var$load("k0nPy"),
    $b79eb7115a8fa21b$var$load("19QIS"),
    $b79eb7115a8fa21b$var$load("76iIp"),
    $b79eb7115a8fa21b$var$load("az9CK"),
    $b79eb7115a8fa21b$var$load("8xx1l"),
    $b79eb7115a8fa21b$var$load("3Xhte"),
    $b79eb7115a8fa21b$var$load("3Kg3S"),
    $b79eb7115a8fa21b$var$load("gPjUw"),
    $b79eb7115a8fa21b$var$load("grjq7"),
    $b79eb7115a8fa21b$var$load("8Ew6s"),
    $b79eb7115a8fa21b$var$load("umglN"),
    $b79eb7115a8fa21b$var$load("9GMEV"),
    $b79eb7115a8fa21b$var$load("g8jRY"),
    $b79eb7115a8fa21b$var$load("84LYM"),
    $b79eb7115a8fa21b$var$load("1aPQ5"),
    $b79eb7115a8fa21b$var$load("4YwES"),
    $b79eb7115a8fa21b$var$load("2Xd3I"),
    $b79eb7115a8fa21b$var$load("8FnXP"),
    $b79eb7115a8fa21b$var$load("3pn87"),
    $b79eb7115a8fa21b$var$load("6tsCm"),
    $b79eb7115a8fa21b$var$load("49e27"),
    $b79eb7115a8fa21b$var$load("7EJ3Q"),
    $b79eb7115a8fa21b$var$load("j5GZH"),
    $b79eb7115a8fa21b$var$load("gLGsg"),
    $b79eb7115a8fa21b$var$load("jvHRs"),
    $b79eb7115a8fa21b$var$load("dChec"),
    $b79eb7115a8fa21b$var$load("9XYQ9"),
    $b79eb7115a8fa21b$var$load("3w411"),
    $b79eb7115a8fa21b$var$load("eY3St"),
    $b79eb7115a8fa21b$var$load("bkd4T"),
    $b79eb7115a8fa21b$var$load("6wr18"),
    $b79eb7115a8fa21b$var$load("kjZZD"),
    $b79eb7115a8fa21b$var$load("Wowvf"),
    $b79eb7115a8fa21b$var$load("1qlDN"),
    $b79eb7115a8fa21b$var$load("1yVM6"),
    $b79eb7115a8fa21b$var$load("dRpV3"),
    $b79eb7115a8fa21b$var$load("ffEVr"),
    $b79eb7115a8fa21b$var$load("5InDs"),
    $b79eb7115a8fa21b$var$load("fZt2F"),
    $b79eb7115a8fa21b$var$load("8e9ys"),
    $b79eb7115a8fa21b$var$load("fHo9c"),
    $b79eb7115a8fa21b$var$load("6u1hm"),
    $b79eb7115a8fa21b$var$load("4xmPF"),
    $b79eb7115a8fa21b$var$load("jryxA"),
    $b79eb7115a8fa21b$var$load("dWZbK"),
    $b79eb7115a8fa21b$var$load("iqKwT"),
    $b79eb7115a8fa21b$var$load("kUbUu"),
    $b79eb7115a8fa21b$var$load("beE2d"),
    $b79eb7115a8fa21b$var$load("hhss7"),
    $b79eb7115a8fa21b$var$load("7EorR"),
    $b79eb7115a8fa21b$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("jbuqY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6f90fb0ae36f35f$export$7faac1b59c375dfa = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oUMKP",
    name: "Nav3Layout",
    loader: async ()=>(await (parcelRequire("81AHd"))).PageLayout
});
module.exports["Nav3Layout"] = $f6f90fb0ae36f35f$export$7faac1b59c375dfa;

});

parcelRegister("81AHd", function(module, exports) {

let $5d7ae1c8a497d44a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d7ae1c8a497d44a$var$load("k0nPy"),
    $5d7ae1c8a497d44a$var$load("6wr18"),
    $5d7ae1c8a497d44a$var$load("aWd5V"),
    $5d7ae1c8a497d44a$var$load("3pn87"),
    $5d7ae1c8a497d44a$var$load("6tsCm"),
    $5d7ae1c8a497d44a$var$load("49e27"),
    $5d7ae1c8a497d44a$var$load("j5GZH"),
    $5d7ae1c8a497d44a$var$load("2F69B"),
    $5d7ae1c8a497d44a$var$load("ffEVr"),
    $5d7ae1c8a497d44a$var$load("fZt2F"),
    $5d7ae1c8a497d44a$var$load("jryxA"),
    $5d7ae1c8a497d44a$var$load("dWZbK"),
    $5d7ae1c8a497d44a$var$load("beE2d"),
    $5d7ae1c8a497d44a$var$load("hhss7"),
    $5d7ae1c8a497d44a$var$load("7EorR"),
    $5d7ae1c8a497d44a$var$load("a6eof")
]).then(()=>parcelRequire('2xpE0'));

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("ezLwY", function(module, exports) {
parcelRequire("cEgln");
var $3IK76 = parcelRequire("3IK76");


var $cpjd2 = parcelRequire("cpjd2");

const $a9c9343047c8f651$var$contexts = {};
const $a9c9343047c8f651$var$runSafely = (fn)=>{
    try {
        fn();
    } catch (e) {
        // TODO: find a real fix for this issue HOT-82965 | CONFCLOUD-58951
        console.error(e);
    }
};
const $a9c9343047c8f651$export$2cd8252107eb640b = ()=>{
    (0, $cpjd2.requireLegacyWRM)([
        'wrc!confluence-keyboard-shortcuts-batch'
    ], ()=>{
        $a9c9343047c8f651$var$runSafely(()=>{
            (0, $3IK76.bind)('register-contexts.keyboardshortcuts', (e, data)=>{
                const { enableContext: enableContext } = data.shortcutRegistry;
                Object.entries($a9c9343047c8f651$var$contexts).forEach(([context, enabled])=>{
                    if (enabled) enableContext(context);
                });
            });
            (0, $3IK76.trigger)('initialize.keyboardshortcuts');
        });
    }, ()=>{});
};
const $a9c9343047c8f651$export$e758fd0259c79269 = ()=>{
    // We need to disable all shortcuts and enable again
    // the ones still available as the currrent library doesn't expose a
    // method for removing just one context and we want to keep previous
    // added contexts alive
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
        (0, $3IK76.trigger)('initialize.keyboardshortcuts');
    });
};
const $a9c9343047c8f651$var$makeSetContext = (enable)=>(newContexts)=>{
        if (!Array.isArray(newContexts)) newContexts = [
            newContexts
        ];
        newContexts.forEach((context)=>{
            if ($a9c9343047c8f651$var$contexts[context] !== enable) {
                $a9c9343047c8f651$var$contexts[context] = enable;
                $a9c9343047c8f651$export$e758fd0259c79269();
            }
        });
    };
const $a9c9343047c8f651$export$2ca78a0e32b5ba4e = $a9c9343047c8f651$var$makeSetContext(true);
const $a9c9343047c8f651$export$48a00fd3a2cf40e0 = $a9c9343047c8f651$var$makeSetContext(false);
const $a9c9343047c8f651$export$4794d9b1949031cf = ()=>{
    $a9c9343047c8f651$var$runSafely(()=>{
        (0, $3IK76.trigger)('remove-bindings.keyboardshortcuts');
    });
};
module.exports["init"] = $a9c9343047c8f651$export$2cd8252107eb640b;
module.exports["enableContext"] = $a9c9343047c8f651$export$2ca78a0e32b5ba4e;
module.exports["disableContext"] = $a9c9343047c8f651$export$48a00fd3a2cf40e0;
module.exports["teardown"] = $a9c9343047c8f651$export$4794d9b1949031cf;

});

parcelRegister("cEgln", function(module, exports) {
$parcel$export(module.exports, "trigger", () => (parcelRequire("3IK76")).trigger);
$parcel$export(module.exports, "bind", () => (parcelRequire("3IK76")).bind);
$parcel$export(module.exports, "unbind", () => (parcelRequire("3IK76")).unbind);

var $3IK76 = parcelRequire("3IK76");


});

parcelRegister("3IK76", function(module, exports) {

var $6g1oe = parcelRequire("6g1oe");


var $jnN7b = parcelRequire("jnN7b");

function $2b59405ae3db7385$export$2385a24977818dd0(eventType, eventData, handler) {
    if (typeof handler === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData, handler);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).bind(eventType, eventData);
}
function $2b59405ae3db7385$export$433e98592e7124fd(eventType, handler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).unbind(eventType, handler);
}
function $2b59405ae3db7385$export$e614dc9140f7ae71(eventType, extraParameters) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jnN7b)))((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe)))).trigger(eventType, extraParameters);
}
module.exports["bind"] = $2b59405ae3db7385$export$2385a24977818dd0;
module.exports["unbind"] = $2b59405ae3db7385$export$433e98592e7124fd;
module.exports["trigger"] = $2b59405ae3db7385$export$e614dc9140f7ae71;

});

parcelRegister("jnN7b", function(module, exports) {
module.exports = jQuery;

});

parcelRegister("fmuCC", function(module, exports) {

let $b2f0a9f0e00b7e22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2f0a9f0e00b7e22$var$load("lgm1i").then(()=>parcelRequire('04Nru'));

});

parcelRegister("jzEl8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $9HkI0 = parcelRequire("9HkI0");

const $6cbcb1ce2cb81a03$var$REPLACED_MARKER = 'data-replaced';
const $6cbcb1ce2cb81a03$var$CLONE_MARKER = 'data-clone';
class $6cbcb1ce2cb81a03$export$a1d3010d20ec2131 extends (0, $42omo.PureComponent) {
    getLegacyElements() {
        const { rootNode: rootNode = window.document, selectors: selectors = [] } = this.props;
        if (!rootNode) return [];
        return Array.from(rootNode.querySelectorAll(selectors.join(',')));
    }
    getDomElementAttrsMap(domElement) {
        if (!domElement.hasAttributes()) return {};
        return Object.values(domElement.attributes).reduce((acc, attr)=>{
            acc[attr.name] = attr.value;
            return acc;
        }, {});
    }
    replaceDOMElementsWithPortal() {
        const { deleteExistingContent: deleteExistingContent, replacePlaceholderWith: replacePlaceholderWith, portalNode: portalNode } = this.props;
        this.workerInProgress = true;
        this.getLegacyElements().forEach((node)=>{
            const currentNodeAttrs = this.getDomElementAttrsMap(node);
            if (currentNodeAttrs[$6cbcb1ce2cb81a03$var$REPLACED_MARKER] || currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER]) return; // do not clone clones or already cloned nodes
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            node.setAttribute($6cbcb1ce2cb81a03$var$REPLACED_MARKER, true);
            // @ts-expect-error FIXME: `true` here probably needs to be replaced with `"true"`
            currentNodeAttrs[$6cbcb1ce2cb81a03$var$CLONE_MARKER] = true;
            currentNodeAttrs['key'] = currentNodeAttrs.id || (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            let targetNode = node;
            if (replacePlaceholderWith) {
                targetNode = window.document.createElement(replacePlaceholderWith.elementName);
                const attributes = replacePlaceholderWith.attributes || {};
                for(const attr in attributes)targetNode.setAttribute(attr, attributes[attr]);
                node.parentNode.replaceChild(targetNode, node);
            }
            if (deleteExistingContent) while(targetNode.firstChild)targetNode.removeChild(targetNode.firstChild);
            if (portalNode) {
                const reactEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(portalNode, currentNodeAttrs);
                this.portals.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(reactEl, targetNode));
            }
        });
        const attemptsLeft = this.state.attemptsLeft - 1;
        this.setState({
            attemptsLeft: attemptsLeft
        });
        if (attemptsLeft > 0) window.setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, this.props.retryDelay);
        else this.workerInProgress = false;
    }
    render() {
        if (this.state.attemptsLeft > 0 && !this.workerInProgress) setTimeout(()=>{
            this.replaceDOMElementsWithPortal();
        }, 0);
        return this.portals.map((item)=>item);
    }
    constructor(...args){
        super(...args);
        this.state = {
            attemptsLeft: this.props.attempts ?? 0
        };
        this.workerInProgress = false;
        this.portals = [];
    }
}
$6cbcb1ce2cb81a03$export$a1d3010d20ec2131.defaultProps = {
    attempts: 1,
    retryDelay: 50,
    deleteExistingContent: true
};
module.exports["LegacyDOMBridge"] = $6cbcb1ce2cb81a03$export$a1d3010d20ec2131;

});

parcelRegister("5qwh1", function(module, exports) {

let $3f386a518f113b7b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f386a518f113b7b$var$load("6wr18"),
    $3f386a518f113b7b$var$load("j06N4"),
    $3f386a518f113b7b$var$load("ffEVr"),
    $3f386a518f113b7b$var$load("Wowvf"),
    $3f386a518f113b7b$var$load("hhss7"),
    $3f386a518f113b7b$var$load("lwfE5")
]).then(()=>parcelRequire('MkVVm'));

});

parcelRegister("2NJWg", function(module, exports) {

let $20a3cae097b49b58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20a3cae097b49b58$var$load("6wr18"),
    $20a3cae097b49b58$var$load("ffEVr"),
    $20a3cae097b49b58$var$load("Wowvf"),
    $20a3cae097b49b58$var$load("hhss7"),
    $20a3cae097b49b58$var$load("d7sp9")
]).then(()=>parcelRequire('4Au5p'));

});

parcelRegister("cq0jI", function(module, exports) {

let $90a828add24c033b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90a828add24c033b$var$load("hhss7"),
    $90a828add24c033b$var$load("ei0Jg")
]).then(()=>parcelRequire('esrJ1'));

});

parcelRegister("7nmkU", function(module, exports) {

let $55ec01e1fb53735b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55ec01e1fb53735b$var$load("hhf8b").then(()=>parcelRequire('cDa2P'));

});

parcelRegister("ax8Zf", function(module, exports) {

let $7ab3f50d85b48d99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ab3f50d85b48d99$var$load("82QsP"),
    $7ab3f50d85b48d99$var$load("an2zh")
]).then(()=>parcelRequire('3Fqft'));

});

parcelRegister("d1Pi6", function(module, exports) {

let $97c327a8a6cb8f32$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $97c327a8a6cb8f32$var$load("82QsP"),
    $97c327a8a6cb8f32$var$load("gJRFC")
]).then(()=>parcelRequire('bQl5d'));

});

parcelRegister("14QAi", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");


var $lzcvT = parcelRequire("lzcvT");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $lzcvT.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

$parcel$global.rwr("3pblT", () => { var $af13447d4d7c1f3f$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3pblT\",\"standalone-navigation-jquery3.489865e2.js\",\"kSVGa\",\"ChangeEditionNotificationDialog.bde70d07.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.c231c57c.js\",\"gmHzx\",\"PageLayout.80261f21.js\",\"i5eMd\",\"cs.6c05555c.js\",\"4UPfH\",\"da.03e4f42a.js\",\"gd4qs\",\"de.5a734e90.js\",\"fviv5\",\"en-GB.e294ef2e.js\",\"hEkXc\",\"en-US.c2f93eaf.js\",\"6oOC9\",\"en-XA.3a61125a.js\",\"le1sE\",\"en-XB.ef4df73b.js\",\"eBoC7\",\"en-ZZ.23f7a202.js\",\"bNv64\",\"es.90ed10a0.js\",\"bAoKR\",\"et.b46b672c.js\",\"4Afgd\",\"fi.89002a37.js\",\"cMubu\",\"fr.0e0b0be6.js\",\"oUCro\",\"hr.665c3168.js\",\"3fLE9\",\"hu.638d7231.js\",\"8hOn0\",\"it.ad3c5b3d.js\",\"h4OCL\",\"ja.4aecc1bc.js\",\"bcQs2\",\"ko.46adbd33.js\",\"aBa7j\",\"nb.5c3eb3a6.js\",\"b544F\",\"nl.abb4d283.js\",\"K6fhx\",\"pl.21acba84.js\",\"gZU54\",\"pt-BR.bcc8aa7d.js\",\"hlJc4\",\"ro.968019e9.js\",\"4Wdqb\",\"ru.b07e7fb6.js\",\"bJMZS\",\"sl.36363fa9.js\",\"exiT6\",\"sr-RS.3450f456.js\",\"jLkRH\",\"sr-YR.99ef1f81.js\",\"dmrYq\",\"sr.7f38330b.js\",\"k10Cs\",\"sv.be5f6a82.js\",\"g5LV7\",\"th.38583473.js\",\"1n8w9\",\"tr.96cdd2ac.js\",\"2QtDQ\",\"uk.4945e86b.js\",\"i2vEA\",\"vi.3d662b6b.js\",\"f1B4n\",\"zh-CN.a2079ada.js\",\"l079e\",\"zh-TW.0240e75e.js\",\"bv8GZ\",\"cs.b8d1c1b1.js\",\"cdeuH\",\"da.42823f82.js\",\"7gF8f\",\"de.8842c040.js\",\"djb49\",\"en-GB.8e93f926.js\",\"koawN\",\"en-US.8577a1a6.js\",\"6htQT\",\"en-XA.66b7e053.js\",\"fi75i\",\"en-XB.9d74a127.js\",\"ksTQ6\",\"en-ZZ.94ab1be8.js\",\"5CGnz\",\"es.98f8e90e.js\",\"X0Jic\",\"et.155c1ee0.js\",\"9Oxgj\",\"fi.f2f3389c.js\",\"kAg8V\",\"fr.368a32d8.js\",\"36XYg\",\"hr.ea791c71.js\",\"fM2oh\",\"hu.f2f9ae82.js\",\"xnqy2\",\"it.351ab003.js\",\"awkVi\",\"ja.99d2f833.js\",\"11DLa\",\"ko.8aeaf96b.js\",\"barSq\",\"nb.4503e9a5.js\",\"a8heY\",\"nl.6070b16e.js\",\"6hlNE\",\"pl.9a5b0b0f.js\",\"2bqSD\",\"pt-BR.10f91e79.js\",\"j6IGj\",\"ro.b5d74be6.js\",\"bJykp\",\"ru.2a448b30.js\",\"7Rbde\",\"sl.9bd17812.js\",\"l8auu\",\"sr-RS.de35f66e.js\",\"3ColL\",\"sr-YR.6d75fa4f.js\",\"2VSOH\",\"sr.cbf031a6.js\",\"dh2Er\",\"sv.e6031ecb.js\",\"kyBJI\",\"th.ea68a7ea.js\",\"eBLgB\",\"tr.a4d35ce1.js\",\"ahhGv\",\"uk.13d42b80.js\",\"1Zesg\",\"vi.e3d9da82.js\",\"eLlpV\",\"zh-CN.914fb213.js\",\"bV8sS\",\"zh-TW.90b55434.js\",\"1jsQH\",\"cs.688247af.js\",\"deyvi\",\"da.ce01a3f4.js\",\"6dERU\",\"de.196d0286.js\",\"kTurq\",\"en-GB.4030ce19.js\",\"fbIIm\",\"en-US.0fcdf1ae.js\",\"7l3it\",\"en-XA.f4eaf1a1.js\",\"i64HJ\",\"en-XB.35a275e0.js\",\"j0PWv\",\"en-ZZ.6e53f76e.js\",\"dlmud\",\"es.a37dad44.js\",\"7snhF\",\"et.20d4d799.js\",\"cbkj0\",\"fi.c129a5d2.js\",\"17m16\",\"fr.d48d2214.js\",\"eQZk8\",\"hr.e3f3497b.js\",\"b4NO6\",\"hu.d63219d9.js\",\"1K1Fj\",\"it.68b18a63.js\",\"38sfA\",\"ja.05e83d89.js\",\"bjmre\",\"ko.5d08c8ec.js\",\"asvK9\",\"nb.b60c8cb7.js\",\"7v6wU\",\"nl.d417f24d.js\",\"aEpRh\",\"pl.26cf010d.js\",\"3fuR9\",\"pt-BR.b55187ea.js\",\"bSjyK\",\"ro.8940bbdc.js\",\"fMrUo\",\"ru.f0bbf79a.js\",\"glLvq\",\"sl.93d481e6.js\",\"fFGjZ\",\"sr-RS.ddc08819.js\",\"fEAqG\",\"sr-YR.289dc38a.js\",\"e9tHh\",\"sr.14f31eee.js\",\"9eNkX\",\"sv.12cce2b0.js\",\"fTPgj\",\"th.4d360fb6.js\",\"h0uBE\",\"tr.a1624066.js\",\"lKa7i\",\"uk.38ddf7bc.js\",\"9aufD\",\"vi.4cc44e33.js\",\"gDiIK\",\"zh-CN.268ccaa6.js\",\"j9OUx\",\"zh-TW.9fda702e.js\",\"kpHRm\",\"GeneralShortcutListener.d76a2508.js\",\"fZt2F\",\"GeneralShortcutListener.3f2f5bfe.js\",\"82QsP\",\"InProductHelpButton.c7845771.js\",\"6KGrg\",\"EmojiComponent.066f8c57.js\",\"4izLy\",\"NativeCollabComponent.b43bfa9b.js\",\"9V45O\",\"CommentsPanelFilterMenu.6d6c08ce.js\",\"ffEVr\",\"vendors~editor_icon.ebc24313.js\",\"kjZZD\",\"vendors~editor_icon-object.ab574088.js\",\"ffEVr\",\"vendors~editor_icon.ebc24313.js\",\"6wr18\",\"vendors~editor_icon.feb07ee8.js\",\"6wr18\",\"vendors~editor_icon.feb07ee8.js\",\"k0nPy\",\"component-lazy.eb39ea87.js\",\"b0eph\",\"simpleHasher.48fdeea2.js\",\"63cQP\",\"simpleHasher.runtime.27a2e1e8.js\",\"63cQP\",\"simpleHasher.runtime.27a2e1e8.js\",\"hwiu3\",\"NavigationLockout.b1900bd2.js\",\"5rgzC\",\"drag-handle.73ab909e.js\",\"dnVDi\",\"top-nav-items.a5a5fda8.js\",\"7EorR\",\"vendors~editor_atlaskit_md.850f6363.js\",\"iMSgb\",\"log-in.9b553c7d.js\",\"48rvp\",\"app-switcher.41220b81.js\",\"hLjS5\",\"notification.af51f62d.js\",\"kFEyO\",\"top-nav-items.3eede104.js\",\"gY1B8\",\"async.420f18e9.js\",\"35VU5\",\"cs.d801dcbc.js\",\"6W6gh\",\"da.bac7ddcf.js\",\"bfTAm\",\"de.c95398fc.js\",\"fP9up\",\"en_GB.47d12276.js\",\"hc0i6\",\"en.747f8213.js\",\"15E48\",\"en_ZZ.299e4f49.js\",\"jLWG0\",\"es.7e41636e.js\",\"9J49E\",\"fi.89090e5d.js\",\"br9SP\",\"fr.2a048ea9.js\",\"5h4sF\",\"hu.c2dc4635.js\",\"1MV5Z\",\"it.05b27b71.js\",\"iV5Fv\",\"ja.7b259d22.js\",\"7R5mJ\",\"ko.203f86ca.js\",\"5XMUp\",\"nb.e44f5efd.js\",\"jaDFz\",\"nl.405ee529.js\",\"LOg5S\",\"pl.23c5179b.js\",\"lnJdQ\",\"pt_BR.805e95d7.js\",\"hqsLl\",\"ru.c980f637.js\",\"j0btO\",\"sv.9635f53d.js\",\"2YEqr\",\"tr.ddf2ab95.js\",\"7zFV7\",\"th.3ecc11fa.js\",\"fZ22O\",\"uk.04a59e12.js\",\"4tleS\",\"vi.cca22a6d.js\",\"bE6tX\",\"zh_TW.af40ed8f.js\",\"esYD7\",\"zh.8eeac7b4.js\",\"iqKwT\",\"main.2bfb52bc.js\",\"kHOMt\",\"manual-triggers-modal.ac3155e2.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.977a573f.js\",\"7zGAi\",\"CoreInvites.30c95b70.js\",\"7oczk\",\"cs.4da6ec84.js\",\"e2gl6\",\"da.92e1a20b.js\",\"9oo3s\",\"de.949a6b27.js\",\"1ZyUV\",\"es.c52c200d.js\",\"6tijD\",\"et.a748dc81.js\",\"6fkVy\",\"fi.14d12f06.js\",\"5nw5x\",\"fr.99ae2fd0.js\",\"jK12s\",\"hu.c6563fe5.js\",\"6lWvL\",\"is.e7fee0c5.js\",\"kk9To\",\"it.165dc383.js\",\"lyt83\",\"ja.c888829c.js\",\"2uvfp\",\"ko.caee176c.js\",\"4Wx8B\",\"nb.b215ce05.js\",\"huTg5\",\"nl.991f3345.js\",\"fPfEd\",\"pl.fdd8fa15.js\",\"fTYhL\",\"pt_BR.9a48d763.js\",\"dVHhf\",\"pt_PT.137566ba.js\",\"2SsCI\",\"ro.a2a72a07.js\",\"kVi5E\",\"ru.73740831.js\",\"6HoYh\",\"sk.63554299.js\",\"kOAvl\",\"sv.bebc1fbd.js\",\"5ErHy\",\"tr.36b807a9.js\",\"jJzpI\",\"th.64051e8c.js\",\"2PvRH\",\"uk.d1a904b6.js\",\"eUGjU\",\"vi.d80ec259.js\",\"drbCf\",\"zh_TW.d982069e.js\",\"5dk6T\",\"zh.dda96faa.js\",\"7pAFt\",\"WarningIllustration.6f86942e.js\",\"2CfIU\",\"WarningIllustration.ec26752f.png\",\"1TOYq\",\"CoreInvites.8d8ff53d.js\",\"5uN9h\",\"arrow-up-right.b9da73d9.js\",\"jPdPC\",\"GoalPanel.35b83d43.js\",\"a4ie9\",\"GoalPanel.runtime.a4b43492.js\",\"bkd4T\",\"datasourceTableView.de3ac659.js\",\"eY3St\",\"datasourceTableView.runtime.6822b8c6.js\",\"az9CK\",\"mention.62785f9f.js\",\"76iIp\",\"mention.runtime.0fa91c88.js\",\"9XYQ9\",\"render.552b6b0b.js\",\"h05Zl\",\"ufo.1597da7c.js\",\"eY3St\",\"datasourceTableView.runtime.6822b8c6.js\",\"76iIp\",\"mention.runtime.0fa91c88.js\",\"a4ie9\",\"GoalPanel.runtime.a4b43492.js\",\"5iVCs\",\"cs.6a4c25c7.js\",\"k7RZQ\",\"da.9877c37f.js\",\"9CFJc\",\"de.bb97d0fd.js\",\"3fPuK\",\"en_GB.9561a37b.js\",\"dUyEb\",\"en_ZZ.c7ec2c16.js\",\"PAD2J\",\"es.8b476d00.js\",\"GNuQo\",\"fi.625ea11d.js\",\"fvsAU\",\"fr.3c57c9b9.js\",\"h7dGJ\",\"hu.a577b1ea.js\",\"kg6sH\",\"it.bd75db28.js\",\"fqF5W\",\"ja.edd3a363.js\",\"1WNp5\",\"ko.b85ae1d4.js\",\"iHPxa\",\"nb.20c3bd75.js\",\"Qf3VH\",\"nl.573e6cdf.js\",\"79OEV\",\"pl.98acd127.js\",\"27dMt\",\"pt_BR.405f85d7.js\",\"bkVVv\",\"ru.c004cf49.js\",\"MLhYA\",\"sv.aaf78479.js\",\"ap7kW\",\"th.a4a6fd4b.js\",\"45YAR\",\"tr.b2cb22e6.js\",\"kqhVG\",\"uk.47e01bb2.js\",\"1susf\",\"vi.1184af6c.js\",\"dl3k2\",\"zh_TW.6e51a40f.js\",\"aquXY\",\"zh.f784abff.js\",\"fYNhh\",\"DevToolsDialog.14036f4d.js\",\"hqXh1\",\"OnboardingStateEditor.72bd2260.js\",\"331QJ\",\"statsigIcon.d38e3090.png\",\"dKuGS\",\"switcherooIcon.4d3f783a.png\",\"fxolc\",\"MigrationsToolingTab.287fdeaf.js\",\"kUbUu\",\"manual-triggers-modal.6b94f0fe.js\",\"dRpV3\",\"inlineCard.29fc707a.js\",\"lkOIY\",\"CommentsPanelFilterMenu.cce03a2c.js\",\"C72jX\",\"DevToolsBanner.819bcd1a.js\",\"jZwEH\",\"ExitBranchDeploy.c9c9c03d.js\",\"dUr0C\",\"FeedbackCollectorButton.952e9ae3.js\",\"9CRBg\",\"StandardToPremiumModal.9e55cd5b.js\",\"lRtGG\",\"dashboard.839aaa25.js\",\"8UKe0\",\"chart-trend-up.daa97715.js\",\"hUapU\",\"StandardToPremiumModal.a5c5b4d1.js\",\"lz2pE\",\"EditionAwarenessUpsell.8d6da776.js\",\"5a167\",\"scheduler-polyfill.ca4ea44c.js\",\"eWCiQ\",\"standard-to-premium-modal.cd132f1c.js\",\"becB8\",\"on-call.39b97377.js\",\"adH3p\",\"roadmap.beb86071.js\",\"gjVBG\",\"devices.13a157d4.js\",\"dNed9\",\"standard-to-premium-modal.bf39c76c.js\",\"gobtw\",\"cs.f2325b58.js\",\"4XclW\",\"da.8823548e.js\",\"5FpC5\",\"de.9f8c75dc.js\",\"Z7F9W\",\"en_GB.88145e4b.js\",\"5vJlz\",\"en_ZZ.6e66d65b.js\",\"kqbLA\",\"es.ebafda9e.js\",\"2xTUv\",\"fi.e29037f1.js\",\"ke5Ak\",\"fr.c635078e.js\",\"78Xv1\",\"hu.36e2e3d5.js\",\"9WYDz\",\"it.b621bab0.js\",\"14Xp5\",\"ja.00759942.js\",\"5YZ43\",\"ko.cb3af28f.js\",\"hcAAz\",\"nb.cd8afc0a.js\",\"a3CGb\",\"nl.7356521a.js\",\"3jRvQ\",\"pl.7af8622a.js\",\"3eKFX\",\"pt_BR.24688c8c.js\",\"2cWJ7\",\"ru.b416633d.js\",\"7io6v\",\"sv.370b80d6.js\",\"bcDrQ\",\"th.aaf28806.js\",\"23xaC\",\"tr.5a5f7532.js\",\"dBkXE\",\"uk.f9026017.js\",\"fQKkM\",\"vi.09fcf459.js\",\"cXjwK\",\"zh_TW.2cb7259f.js\",\"fCfjN\",\"zh.9966cb4b.js\",\"6u1hm\",\"CommentsPanelFilterMenu.b7dc3e9f.js\",\"eeaKR\",\"credit-card.39a2b6fa.js\",\"eufZR\",\"PageHeaderLoomEntryPoint.401a6f9e.js\",\"3FT39\",\"cs.b4709f80.js\",\"7QoTg\",\"da.e788fd22.js\",\"d1Lrf\",\"de.2dd434ed.js\",\"kM5GB\",\"en_GB.82797faf.js\",\"5506N\",\"en_ZZ.a7c6e9ad.js\",\"7ioy0\",\"es.a4af58eb.js\",\"kZ6zs\",\"fi.aaa32cea.js\",\"phbpE\",\"fr.0e55ec47.js\",\"6pKhl\",\"hu.8153cc96.js\",\"hzLOt\",\"it.75418871.js\",\"1M8mW\",\"ja.6ef7e39a.js\",\"eHQAY\",\"ko.36b5b8ee.js\",\"8exPB\",\"nb.9e9e6a03.js\",\"knfAP\",\"nl.dbd0c739.js\",\"ljRXP\",\"pl.7932a8db.js\",\"bEb8c\",\"pt_BR.e2f7c972.js\",\"c7JYF\",\"ru.a2b7a11a.js\",\"ari8V\",\"sv.1d81f4cf.js\",\"kfrHX\",\"th.0d215dce.js\",\"aWToy\",\"tr.9415008a.js\",\"4ns5x\",\"uk.baa17c6e.js\",\"7bfAn\",\"vi.26b5754b.js\",\"gftgT\",\"zh_TW.b791e5b1.js\",\"6YVlG\",\"zh.ccb62d88.js\",\"lxvzP\",\"EditionAwarenessUpsell.9d2fd068.js\",\"830Zv\",\"HubSettingsNavigation.32b43774.js\",\"5E6oP\",\"AutomationOnBoarding.e83dc203.js\",\"1TfYn\",\"AutomationLight.3a471294.png\",\"5ZTDJ\",\"AutomationDark.427f07ad.png\",\"cD5e0\",\"GlobalNavigationComponent.b2fcb4eb.js\",\"k7TXX\",\"people-teams.d3947ed6.js\",\"64UoX\",\"TeamProfileCardEntryPoint.e4182137.js\",\"48eS0\",\"cs.0a70d1eb.js\",\"lak6L\",\"da.c7babb2f.js\",\"inCHL\",\"de.cbe7feb8.js\",\"lLx4a\",\"en.e8d1a804.js\",\"auTAr\",\"en_GB.61079520.js\",\"9pxVf\",\"en_ZZ.deff80f1.js\",\"4cEzx\",\"es.612e2fbc.js\",\"iUIL3\",\"et.8f07e723.js\",\"lADZV\",\"fi.7a3ccf21.js\",\"1QHKh\",\"fr.6e11f6ae.js\",\"2Tjcq\",\"hu.f16e562a.js\",\"4WVVc\",\"is.aa3b7b54.js\",\"1QNch\",\"it.a968aca7.js\",\"jQCyA\",\"ja.30766580.js\",\"aQwae\",\"ko.58405243.js\",\"cS1j1\",\"nb.6303b090.js\",\"48pzM\",\"nl.9b8910a0.js\",\"c4a0F\",\"pl.768774fc.js\",\"cBmO4\",\"pt_PT.fb87e247.js\",\"9e3Ob\",\"pt_BR.881d260c.js\",\"7Hoje\",\"ro.6553ad3e.js\",\"4dj0m\",\"ru.3a560477.js\",\"j5HYK\",\"sk.89deb301.js\",\"1VsiM\",\"sv.995d4e94.js\",\"8CqFM\",\"tr.3a5f318f.js\",\"5bAmA\",\"th.1e8306bc.js\",\"i0Evx\",\"uk.3a4c5d55.js\",\"j8OKz\",\"vi.48908404.js\",\"2s1Lz\",\"zh.20bc79bb.js\",\"iI3rq\",\"zh_TW.f90769ea.js\",\"k9ktU\",\"OnboardingNudgeTooltip.809176eb.js\",\"lz0X6\",\"OnboardingNudgeTooltip.b4e6cbd1.js\",\"dFhUX\",\"invited-app-popup.4c209f23.js\",\"h2810\",\"PersistentInvitePeopleButton.e75148d9.js\",\"aGsq7\",\"companyHubItemCallback.b937236a.js\",\"SepNY\",\"analyticsCallbacks.738ed835.js\",\"69GDg\",\"Home.eb3dbfc7.gif\",\"bxhxc\",\"Home-dark.b4541437.gif\",\"216TD\",\"Home-placeholder.72eb75ff.png\",\"7Bv6F\",\"Home-placeholder-dark.86521bfc.png\",\"03cvv\",\"errorWarning.3a015e54.svg\",\"dvjk6\",\"noResultsDark.90199792.svg\",\"57B0v\",\"noResultsLight.5ffcf568.svg\",\"2yM8Y\",\"RecentContentMenu.3be992dd.js\",\"b3B6t\",\"coffeeChat.72f8b026.svg\",\"dbIft\",\"emptyStarBox.3b01bf42.svg\",\"7JfxY\",\"SpacesDropdown.d8d11a20.js\",\"9JWXo\",\"ImportContentDrawer.67d337e1.js\",\"6aruy\",\"media-client-react.813052e9.js\",\"ht6hk\",\"cardWithMediaClient.7d0794d2.js\",\"b8BDn\",\"js.a0af0607.js\",\"dLFEp\",\"png-chunks-extract.01966068.js\",\"8Q66p\",\"media.14058cc3.js\",\"cCWZm\",\"dropzone.1ad00f91.js\",\"6vhrJ\",\"24.25e29644.js\",\"dT77m\",\"media-viewer-error-boundary.7f752e6f.js\",\"huUvS\",\"16.f4d29d37.js\",\"1oiJ6\",\"16.9b0cfada.js\",\"lxiFd\",\"16.bfa31662.js\",\"eDqo1\",\"16.c9c1057f.js\",\"6HBYC\",\"16.10256d2c.js\",\"bYxCZ\",\"16.733e7fd3.js\",\"eTBsW\",\"16.6f5a520f.js\",\"020xd\",\"16.54d36bc8.js\",\"ls0Um\",\"16.055b6b2a.js\",\"eVYW1\",\"16.ae0fb140.js\",\"f35QR\",\"16.10d23cc6.js\",\"lE3cg\",\"media-picker-analytics-error-boundary.5159dd30.js\",\"hqblC\",\"browser.e95ef711.js\",\"eMbU0\",\"SpaceSelector.3cf66c3f.js\",\"3wN5D\",\"ExternalSpaceLozenge.de41bba8.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.2b2efc3c.js\",\"dWZbK\",\"emoji.5fe0bf5a.js\",\"jryxA\",\"emoji.runtime.b4e6a7c5.js\",\"7Gmjr\",\"panel.632dfa00.js\",\"hGfPD\",\"panel.runtime.6079d0b1.js\",\"jXx9i\",\"NativeCollabComponent.7ae57328.js\",\"2mt3f\",\"DetailsPanelHeaderIcon.8177f115.js\",\"lnnYm\",\"DetailsPanelHeaderIcon.e4a0371b.js\",\"hGfPD\",\"panel.runtime.6079d0b1.js\",\"jryxA\",\"emoji.runtime.b4e6a7c5.js\",\"5eYbH\",\"fileIconLight.abb757fe.png\",\"f27VQ\",\"fileIconDark.2e9120d4.png\",\"eQRZh\",\"alexander.61c8c5b8.png\",\"k3UTH\",\"milo.2bdab175.png\",\"bpNrn\",\"vania.0f716e7d.png\",\"1SbNU\",\"newUsersIcon.57d15f82.png\",\"4pzfE\",\"entireWorkspaceGraphic.ec7c84e3.png\",\"9EbOe\",\"entireWorkspaceGraphicDark.a2cf125d.png\",\"5v8ge\",\"pageWithSubpagesGraphic.bc63f39a.png\",\"l5ApQ\",\"pageWithSubpagesGraphicDark.048b0716.png\",\"e233E\",\"NotionFileIcon.bf57d29e.png\",\"2HswK\",\"NotionFileIconDark.1bce2172.png\",\"iHoZ2\",\"mapNotionMembersIcon.f5fa6c65.png\",\"mKUlU\",\"mapNotionMembersIconDark.78a4caee.png\",\"lve0S\",\"dontMapNotionMembersIcon.d4b46256.png\",\"fHhNe\",\"dontMapNotionMembersIconDark.8a5a6302.png\",\"idIGV\",\"addRemainingMembersIcon.ed292f87.png\",\"eFqPt\",\"addRemainingMembersIconDark.fcaa97df.png\",\"ahBHt\",\"dontAddRemainingMembersIcon.c16498ed.png\",\"bJ6Qx\",\"dontAddRemainingMembersIconDark.2a9fa7cf.png\",\"jO0Zn\",\"copyPagePermissionsIcon.893f44bc.png\",\"koH91\",\"dontCopyPagePermissionsIcon.57c83ce6.png\",\"4qS5d\",\"createNewSpaceIcon.43619a57.png\",\"7HrUn\",\"createNewSpaceIconDark.1df6e816.png\",\"rGPsx\",\"dontCreateNewSpaceIcon.b35b2829.png\",\"5a1S5\",\"dontCreateNewSpaceIconDark.706b6cfd.png\",\"8R1Rz\",\"spaceTransferLight.b2e70613.png\",\"1e1ep\",\"spaceTransferDark.856b3d0e.png\",\"jGDZO\",\"zipFileIconLight.abb757fe.png\",\"4pvad\",\"zipFileIconDark.2e9120d4.png\",\"4xmnl\",\"spaceTransferIconLight.5eeae605.png\",\"aBnpB\",\"spaceTransferIconDark.9c0b5b2f.png\",\"aRCSw\",\"miroBulkImportIconLight.f695f170.png\",\"dur8E\",\"miroBulkImportIconDark.3dc15c83.png\",\"eGDQk\",\"Miro_Connie_Light.97ddc4df.png\",\"5IkEQ\",\"Miro_Connie_Dark.588133c4.png\",\"d4y04\",\"muralSpacesIllustrationLight.297ed65c.png\",\"hgEBB\",\"muralSpacesIllustrationDark.a5d03bf9.png\",\"4YW3x\",\"inviteMembersIconLight.1a833efb.png\",\"jw4LE\",\"inviteMembersIconDark.1179e32a.png\",\"hoRD8\",\"newSpaceIconLight.9405f85d.png\",\"5ILSM\",\"newSpaceIconDark.9c0b5b2f.png\",\"2Q5QN\",\"muralIcon.75d8302a.png\",\"fK2sh\",\"muralSpacesIllustrationDisconnectedLight.4bd334a6.png\",\"3aNue\",\"muralSpacesIllustrationDisconnectedDark.a6cca434.png\",\"7MlKm\",\"archive.5e2679d9.js\",\"7WcBh\",\"MovePageDialog.ce6f2892.js\",\"b99Vc\",\"ByLineForgeApp.65b0f59d.js\",\"hX5aL\",\"ImportContentModal.bbaa1ae4.js\",\"7QQL7\",\"GlobalCreateContentPopoverMenu.90ff3396.js\",\"kiDFE\",\"CreateSpaceMenuItem.efc8e4e6.js\",\"66kde\",\"ContentTreeOnboarding.aec66e8f.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.dd78c5c3.js\",\"3tVyh\",\"CreateSpacePlusButton.4e520adb.js\",\"9jGiN\",\"DiscoverSection.2678701d.js\",\"brnyq\",\"miro.cb595030.png\",\"1IPtO\",\"slack.ba8f92ff.png\",\"gSraM\",\"invision.8f2e37e4.png\",\"8b1I3\",\"google-drive.d0028a0e.png\",\"6bVkQ\",\"lucidchart.8807407a.png\",\"kIryJ\",\"NotesMenu.2afeddd6.js\",\"j6C8t\",\"notepad.29a984bb.svg\",\"FBIp4\",\"TeamsAppShortcutItem.fa48a67b.js\",\"borwc\",\"CustomizationModal.94d05903.js\",\"9JvEP\",\"customization-modal.41126c71.js\",\"dTsOE\",\"modal.866d2f53.js\",\"9a2oY\",\"home.c75a599b.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.472ce9c9.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"hyzoX\",\"ProjectPanel.0319ddbf.js\",\"6S3Gy\",\"marketplace.8761e365.js\",\"81eQE\",\"hashtag.01b327f2.js\",\"lYhLK\",\"FavouriteButton.35ab28e2.js\",\"k3OeJ\",\"ConversationAssistant.a07864ed.js\",\"fACU5\",\"ConversationAssistant.213497cf.js\",\"hoPZ9\",\"cs.3b577782.js\",\"gyXEE\",\"cs.54a9e612.js\",\"4DYJ5\",\"cs.ae29805e.js\",\"4Mixi\",\"cs.cbb5fe34.js\",\"2Fu3d\",\"da.2c98435e.js\",\"1Mp9N\",\"da.d49841ed.js\",\"hfFxJ\",\"da.4bac143d.js\",\"cjveN\",\"da.835212d1.js\",\"eJgH8\",\"de.553f8aeb.js\",\"dBb6q\",\"de.999b5c94.js\",\"gofGr\",\"de.d8e61a4d.js\",\"8XGJb\",\"de.a2ec1619.js\",\"03aeW\",\"en_GB.0ccf7aa9.js\",\"aSjrK\",\"en_GB.a65deae7.js\",\"5FaEJ\",\"en_ZZ.aeae8448.js\",\"cukQS\",\"en_ZZ.f589829f.js\",\"7NpX8\",\"en_ZZ.56f4bbe2.js\",\"4ViGN\",\"en_ZZ.bb1eba3d.js\",\"9yemY\",\"es.3410410b.js\",\"3CucM\",\"es.b941d673.js\",\"bFU3Y\",\"es.e423bf3a.js\",\"32vlK\",\"es.ac31b31a.js\",\"l2LZP\",\"fi.1471cf98.js\",\"lp8Wm\",\"fi.7854ba62.js\",\"exaJ2\",\"fi.33989446.js\",\"bjoGV\",\"fi.1e513850.js\",\"35Ssm\",\"fr.b7334acd.js\",\"cHWSM\",\"fr.456a53ca.js\",\"hcCcg\",\"fr.a66523c8.js\",\"8oiz7\",\"fr.6f53d7a9.js\",\"ik6u5\",\"hu.7af6dd84.js\",\"b37xN\",\"hu.cffd8ff3.js\",\"j9KTb\",\"hu.fa3f1171.js\",\"hFxmj\",\"hu.cd9b6b61.js\",\"Vt6S9\",\"it.deca9c90.js\",\"7PjNK\",\"it.ce73937a.js\",\"3hjAq\",\"it.620f63c1.js\",\"BXOZB\",\"it.99220f36.js\",\"9GZ76\",\"ja.bf2686b3.js\",\"ktSfi\",\"ja.cd9869f4.js\",\"2bCHJ\",\"ja.d410f0e4.js\",\"9Xiuh\",\"ja.82009b49.js\",\"4sOIV\",\"ko.b67938ec.js\",\"iouLY\",\"ko.77a2b852.js\",\"fdXnq\",\"ko.377862ae.js\",\"7Odo3\",\"ko.f8696b38.js\",\"QTjdE\",\"nb.b7713d4d.js\",\"hPZE5\",\"nb.bc3bab80.js\",\"cItJR\",\"nb.dbba57d8.js\",\"4VkvT\",\"nb.7fc4a303.js\",\"hrf1M\",\"nl.d8763e96.js\",\"dzIm8\",\"nl.736c884e.js\",\"SctKm\",\"nl.d90fd1de.js\",\"g5qJV\",\"nl.27391c7e.js\",\"lsloj\",\"pl.faf2ab4c.js\",\"jqwnR\",\"pl.aa78124e.js\",\"1fJz1\",\"pl.7999c76d.js\",\"dPa6p\",\"pl.39ca0fea.js\",\"iRKhU\",\"pt_BR.23c5b320.js\",\"bGhLc\",\"pt_BR.69377af0.js\",\"9yA8o\",\"pt_BR.e534d362.js\",\"iG4uh\",\"pt_BR.b57aad22.js\",\"aEAsN\",\"ru.00996e0a.js\",\"9v6ER\",\"ru.ad0811e9.js\",\"448N7\",\"ru.1fe1deae.js\",\"9tVE8\",\"ru.65c56da2.js\",\"l6YHr\",\"sv.e08a36b2.js\",\"8Mz40\",\"sv.e48df96b.js\",\"gBDdh\",\"sv.bc06c239.js\",\"6UAlo\",\"sv.575cc5b8.js\",\"6nK39\",\"th.e2448a24.js\",\"fdczG\",\"th.85d0593d.js\",\"hWNfo\",\"tr.5e69c2fc.js\",\"epkdv\",\"tr.f7701f9c.js\",\"8UuQQ\",\"uk.11b615ac.js\",\"3MGOs\",\"uk.f1a414df.js\",\"6BkMx\",\"vi.352470f3.js\",\"innCz\",\"vi.d3e97b33.js\",\"afU9w\",\"zh_TW.15ca144d.js\",\"hF4v3\",\"zh_TW.2ab7e2a2.js\",\"ebljE\",\"zh_TW.cf04c7f7.js\",\"ia9y3\",\"zh_TW.6efc768f.js\",\"7iCpI\",\"zh.1d3eee0d.js\",\"1Tuyb\",\"zh.1e8977fa.js\",\"j4dSZ\",\"zh.fb33a2b6.js\",\"15ncj\",\"zh.f634978a.js\",\"a1VZ3\",\"GlobalNavigationComponent.bead4613.js\",\"hmXd6\",\"fileCabinet.17ae0554.svg\",\"17BHA\",\"noResultsDark.90199792.svg\",\"7S3sF\",\"noResultsLight.5ffcf568.svg\",\"lUQAm\",\"datasourceTableView.54fe6fb3.js\",\"8Tr2S\",\"DetailsPanelHeaderIcon.86c8f6e4.js\",\"aYgZt\",\"SpaceNavigation.03901a71.js\",\"TkY5q\",\"RtPaidFeatureEducationSpotlight.23dea63e.js\",\"cJHFd\",\"Nav3SpaceNavigationContent.e0c7847f.js\",\"ltXeo\",\"PageTree.61ad3f53.js\",\"4JUnA\",\"BulkDeletePagesAction.07729ffa.js\",\"73HOd\",\"BulkDeletePagesAction.daa0707d.js\",\"anGwD\",\"BulkArchivePagesLoader.d1027af3.js\",\"9ftJe\",\"UpdateComposer.65192a63.js\",\"kH8lz\",\"BulkArchivePagesLoader.a28db323.js\",\"6sAbi\",\"ArchivePageAutomationDiscovery.e21f9740.js\",\"gtMen\",\"ShareButton.00eeebeb.js\",\"fzHDF\",\"archive-box.c5ec2eea.js\",\"gODOu\",\"RtPaidFeatureEducationSpotlightTarget.ba19a426.js\",\"dkv9z\",\"PageTreeAfterIcon.3d9651cb.js\",\"9F7vX\",\"CreateContentPopover.db2059b2.js\",\"fQKYr\",\"ConfluenceSmartCreationModal.5f63aa5f.js\",\"k7MRD\",\"showFeedbackFlag.58e54de8.js\",\"cyGuT\",\"feedback-collector.0a12fc76.js\",\"79zof\",\"mention.6b00112b.js\",\"c9Qqc\",\"auto-dev.232d76cf.js\",\"1TK6P\",\"auto-fix.257eceb2.js\",\"grvAy\",\"auto-review.0fe9b7f1.js\",\"23K0q\",\"backlog-buddy.d757d61a.js\",\"3kQkj\",\"comms-crafter.36507020.js\",\"6OXgE\",\"culture.33e027e3.js\",\"cbucA\",\"customer-insight.7dfcf35a.js\",\"bVhr1\",\"decision-director.35d226a4.js\",\"kE0QC\",\"feature-flag-avatar.f9d8e991.js\",\"eVFXf\",\"generic-avatar.cd98d7cb.js\",\"9FhBz\",\"hire-writer.7ebbca98.js\",\"6zB8z\",\"marketing-message-maestro.7404e3da.js\",\"eENGY\",\"my-user-manual.ac6d3669.js\",\"hmlb0\",\"okr-oracle.0602d51c.js\",\"2NGxc\",\"ops-agent.012e195b.js\",\"bPgcq\",\"pitch-perfector.e73b56ef.js\",\"31b1q\",\"product-requirement.2ba2b672.js\",\"8Lh9U\",\"release-notes.3c1911fc.js\",\"6ZzYJ\",\"research-scout.e2c817ef.js\",\"2zIbn\",\"rovo-dev.f6f9366f.js\",\"410SS\",\"social-media-scribe.e5fe68a5.js\",\"z3s9q\",\"team-connection.5f505a11.js\",\"9gqcE\",\"workflow-builder.07423129.js\",\"eipnW\",\"trial-guide.b54ccfd0.js\",\"jdAk9\",\"jsm-rovo-service-agent.c89fe7ed.js\",\"frhR0\",\"main.c8e628a6.js\",\"LQeCh\",\"Rovo-loadingV2.b5f1b3c5.gif\",\"ha91h\",\"Rovo-loadingV2.b5f1b3c5.gif\",\"9gDvs\",\"accessibility.5564f20e.svg\",\"f4pjt\",\"award.214f8776.svg\",\"1A7In\",\"calendar.b3d986a4.svg\",\"hbmJV\",\"checklist.73c2b414.svg\",\"dfz72\",\"community.e0696574.svg\",\"8iDBX\",\"customer.b92e93e7.svg\",\"g9qwo\",\"develop.57b4f578.svg\",\"5MnfW\",\"flowchart.a71ff7c1.svg\",\"92hcC\",\"guidelines.997e35c4.svg\",\"YpFw7\",\"hire-writer.de7ada5b.svg\",\"hPfyy\",\"icons-gears.bfd13e5a.svg\",\"4d6gC\",\"icons-people.f158a567.svg\",\"ckHEC\",\"illustrations.98e8bf43.svg\",\"iXa6x\",\"lightbulb.e4ffc69c.svg\",\"lA2m1\",\"marketing.2c92f054.svg\",\"9DSi1\",\"onboarding.43d000af.svg\",\"69pz5\",\"project-management.8376933a.svg\",\"bFaEu\",\"release-phases.4229641f.svg\",\"4HRl6\",\"resilience.4a0de1ce.svg\",\"kyaih\",\"system-of-work.579d0af3.svg\",\"avXjM\",\"tips.695c0031.svg\",\"g7RCN\",\"trust.ae24e421.svg\",\"klZVQ\",\"user-testing.1d397bb2.svg\",\"aSfft\",\"vision-values.6d647ce6.svg\",\"bDavb\",\"volunteering.f0465fb3.svg\",\"7iOBS\",\"ConfluenceCreateIllustrationLight.e6af8be5.svg\",\"gNGuh\",\"ConfluenceCreateIllustrationDark.6237fca1.svg\",\"bgHzk\",\"ConversationAssistant.6ce7fa87.js\",\"7Vmxp\",\"table.21c55c6c.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.6dd05041.js\",\"7ixUU\",\"datasourceTableView.e1131f7b.js\",\"6cVEd\",\"fire-event.74c5ca8b.js\",\"atfX6\",\"datasourceTableView.607295ec.js\",\"eXGjr\",\"datasourceTableView.57ae9874.js\",\"7fMGd\",\"dark.16cc06e7.svg\",\"8OP1c\",\"light.e350f7db.svg\",\"gywm1\",\"dark.981334ac.svg\",\"29by2\",\"light.d61b1f64.svg\",\"XXMwE\",\"dark.90199792.svg\",\"cqbvn\",\"light.5ffcf568.svg\",\"bEo2Z\",\"standard.6c3cc6ed.svg\",\"8makw\",\"datasourceTableView.851020c6.js\",\"5pvpJ\",\"datasourceTableView.436932dc.js\",\"fSNo2\",\"refresh.b81287fe.js\",\"2YffH\",\"en.4aaf88c4.js\",\"7Lkvk\",\"en_GB.8a7d0688.js\",\"2RQvP\",\"en_GB.4a59edc0.js\",\"hdvZr\",\"en_GB.702092de.js\",\"5IaSN\",\"et.8534a99f.js\",\"fModo\",\"is.ef98b365.js\",\"aGECO\",\"pt_PT.b38348c7.js\",\"aOdaf\",\"ro.60ad0b8a.js\",\"5WkxF\",\"sk.0c3a448b.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"77dzh\",\"tr.46a56f35.js\",\"6NHX3\",\"tr.509cc515.js\",\"9Yw4z\",\"tr.fb23115c.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"2lsX7\",\"main.33e42dd9.js\",\"c0JsV\",\"link-picker.18d76c74.js\",\"3QIea\",\"modal.75a403c8.js\",\"jYGxH\",\"th.979bffc6.js\",\"czAFw\",\"tr.681a53e9.js\",\"c0Efy\",\"uk.94c09e9c.js\",\"dKBuH\",\"vi.58f3aadb.js\",\"anP9P\",\"error.5fbc7fe9.png\",\"cU3hB\",\"smart-creation-wrapper.5040a582.js\",\"gqFUq\",\"ConfluenceSmartCreationModal.8127eaf9.js\",\"lPsQk\",\"error-smart-create-icon.94df62fb.svg\",\"hFXeG\",\"main.0462ba49.js\",\"jn9xB\",\"Create-with-Rovo-Loading-Dark-Mode.07403868.gif\",\"81ouS\",\"Create-with-Rovo-Loading-Light-Mode.41a65ca6.gif\",\"lbiHc\",\"database-drafts-icon.3feeafba.png\",\"kroVc\",\"docs-drafts-icon.89c35078.png\",\"jG9WP\",\"whiteboard-drafts-icon.1347e699.png\",\"ayspZ\",\"ui.23263196.js\",\"37ldp\",\"block.df3ffa83.js\",\"7PMju\",\"refractor.4bbd520a.js\",\"7f9Fz\",\"root-component.2ecfdf2b.js\",\"iraZ1\",\"react-markdown.6b7d8d1d.js\",\"3GB1F\",\"conversation-assistant-viz.e4d00e6e.js\",\"slRZz\",\"charts.8ea62321.js\",\"bQUGu\",\"GoalPanel.fcba4a6f.js\",\"3GzsK\",\"GoalPanel.5891d979.js\",\"k5bNG\",\"charts.a4f1c651.js\",\"7sx4A\",\"charts.9a498e8a.js\",\"jfCh6\",\"rovo.b06223c6.png\",\"2SwYm\",\"deep-research-icon-dark-mode.184ef24b.svg\",\"aSjVK\",\"deep-research-icon-light-mode.626661c3.svg\",\"bHRnB\",\"deep-research-icon.837407f5.svg\",\"7rHnm\",\"rovo-chat-bubbles.ad8ad13a.svg\",\"ixTAZ\",\"text-field.3fa52048.js\",\"bvkpZ\",\"text-area.732a8a35.js\",\"e3d45\",\"date-time-picker.16f5bb45.js\",\"d34hg\",\"gic-anywhere.dfde0b69.js\",\"i7RPm\",\"gic-anywhere.38a5e9e8.js\",\"cUIaj\",\"CommentEditor.cc652a82.js\",\"gvJDI\",\"generic-issue-type-icon.b13acfc5.svg\",\"i7J2B\",\"avatar-with-arrow-darkmode.d9464bf1.svg\",\"2FbWf\",\"avatar-with-arrow.71e68580.svg\",\"3Xxws\",\"avatar-with-lock-darkmode.39948dbb.svg\",\"85zTu\",\"avatar-with-lock.b0750eee.svg\",\"girkx\",\"pencilled-field-with-arrow-darkmode.9a09e770.svg\",\"dCfoG\",\"pencilled-field-with-arrow.6615a67d.svg\",\"dG1sE\",\"text-field-with-lock-darkmode.6b00710c.svg\",\"jQD4g\",\"text-field-with-lock.548927e7.svg\",\"hZ3Uy\",\"text-field-with-tick-darkmode.49503976.svg\",\"h1tvj\",\"text-field-with-tick.9650a889.svg\",\"8jz4U\",\"mcp-server-tools.b45cf60d.js\",\"jALB7\",\"database-icon.af3511fd.svg\",\"aLbrw\",\"live-docs-icon.5595b5be.svg\",\"fe7gr\",\"page-icon.4dd78b86.svg\",\"cknJE\",\"preview-card-database-header.8549ac7f.svg\",\"gMvyv\",\"preview-card-page-header.8639e9c6.svg\",\"6p1RF\",\"preview-card-whiteboard-header.a8b554de.svg\",\"fuzt0\",\"whiteboard-icon.552d11f4.svg\",\"lXkAL\",\"InformationModal.9f8ea6cc.js\",\"2xz6W\",\"feedback-flag.66cb31f5.js\",\"lc53W\",\"local-frontend-components.a413213a.js\",\"3Bbwl\",\"filter.6126c2d3.js\",\"a4yJG\",\"folder-open.6a0f53ed.js\",\"7xgYF\",\"build-icon-no-prompts.73453fad.svg\",\"5m8Kg\",\"analyze-icon.5c4c7ecb.svg\",\"b2eNj\",\"brainstorm-icon.f24d96f2.svg\",\"4ofWJ\",\"create-icon.59c93a6c.svg\",\"jdeyK\",\"execute-icon.d7c359b6.svg\",\"5faYL\",\"find-icon.63225fe6.svg\",\"80D6g\",\"general-prompt-icon.5618909f.svg\",\"lPxCc\",\"learn-icon.7e0ca0d6.svg\",\"aDBGk\",\"review-icon.7da7ded4.svg\",\"grAf6\",\"summarize-icon.5a91c5af.svg\",\"6SM2I\",\"cs.fced59d2.js\",\"ivb6v\",\"da.efd8e956.js\",\"7LTI5\",\"de.92bf7124.js\",\"hgUao\",\"en_GB.ccd34138.js\",\"j787T\",\"en_ZZ.d113c972.js\",\"aEmWg\",\"es.6dbeaf2e.js\",\"eR8Wp\",\"fi.75babc08.js\",\"72xPj\",\"fr.46a790f6.js\",\"1OOEW\",\"hr.11a83462.js\",\"jPs8I\",\"hu.065572e0.js\",\"8dbN2\",\"it.66391f2b.js\",\"i9Imr\",\"ja.b6e444b2.js\",\"kYLWR\",\"ko.ccd74e63.js\",\"lC975\",\"nb.92290c76.js\",\"jyEOm\",\"nl.1cfc5dc4.js\",\"agZBy\",\"pl.aa296ade.js\",\"i0zKK\",\"pt_BR.9268b557.js\",\"2zDhc\",\"ru.f0101ff1.js\",\"4eO7d\",\"sl.1b3b6bcd.js\",\"1Tr0G\",\"sr_RS.2f9f0304.js\",\"fGDED\",\"sr_YR.f4aec80b.js\",\"2l8tR\",\"sv.f8d2cb8e.js\",\"4JJfl\",\"th.dff0bbe3.js\",\"hYpqC\",\"tr.25362355.js\",\"cjEKg\",\"uk.49c97ab6.js\",\"faxoo\",\"vi.0294c992.js\",\"a2X8X\",\"zh_TW.0a2a8960.js\",\"4arx8\",\"zh.03e89d1a.js\",\"jTExV\",\"object-list-flyout-content.a019d8a8.js\",\"je720\",\"no-results-dark.90199792.svg\",\"5CyuG\",\"no-results-light.5ffcf568.svg\",\"cGPv6\",\"empty.72f8b026.svg\",\"9Y153\",\"starred-empty.227ae17e.svg\",\"1B7k9\",\"error-state-dark.fd22b26d.svg\",\"9Ftrm\",\"error-state-light.f4c1cfc8.svg\",\"b9XqL\",\"no-results-dark.90199792.svg\",\"d019N\",\"no-results-light.5ffcf568.svg\",\"igAEH\",\"filters-dropdown.5617daaa.js\",\"5jNvH\",\"object-list-flyout-content.c8dc55dd.js\",\"foMSI\",\"content.b5d27dbf.js\",\"pHE7k\",\"customization-modal.6c8055a8.js\",\"6nDfv\",\"esm.19a6f7c2.js\",\"sj9Xz\",\"RelatedLinksModal.8be46b1a.js\",\"ht5OT\",\"RelatedLinksModal.runtime.d5f3be7c.js\",\"8MfZE\",\"component-lazy.4e93b08a.js\",\"855o0\",\"component-lazy.runtime.6c634bba.js\",\"8xx1l\",\"component-lazy.8a39ea92.js\",\"3w411\",\"modal.3a9d407b.js\",\"h9rdz\",\"modal.087d8fb5.js\",\"b2FtX\",\"browse-agents.9250abda.js\",\"jMj86\",\"browse-agents.64a3d670.js\",\"3EXzu\",\"render.8334e51a.js\",\"dsd0q\",\"FullPageEditorComponent.ce31d786.js\",\"dmXVq\",\"FullPageEditorComponent.runtime.c1d87e93.js\",\"gVbhn\",\"FullPageEditorComponent.bb534505.js\",\"6QICh\",\"FullPageEditorComponent.54cfb234.js\",\"8Vm0B\",\"FullPageEditorComponent.runtime.66f7a98d.js\",\"lhRZW\",\"FullPageEditorComponent.640e954b.js\",\"49cor\",\"agent-section.889df7e0.js\",\"fGTig\",\"CommentEditor.2986bb6d.js\",\"3fdRd\",\"recommended-agents-preloader.6fd36271.js\",\"1yrlK\",\"assets.a36da6b7.js\",\"czqcb\",\"chart-bar-line.30aba5fa.js\",\"iAqyW\",\"ai-generative-text.a87325fb.js\",\"8vVzT\",\"chart-pie.317622ae.js\",\"hpUn4\",\"plan.accf305e.js\",\"l4YAS\",\"project-status.e6d456e7.js\",\"6HxBR\",\"merge-success.ee5b4447.js\",\"fjOTL\",\"person-add.2ade7731.js\",\"4rKYa\",\"person-added.bc078926.js\",\"8Qv5g\",\"transition.dc10ff19.js\",\"7kkP6\",\"playlist-add.9dfed2d4.js\",\"k2R9e\",\"playlist-remove.1cea3c51.js\",\"euJgP\",\"preview-bg.12045916.svg\",\"2fk6g\",\"16.39b6cb2e.js\",\"72780\",\"24.43557862.js\",\"hszIA\",\"24.9fce27aa.js\",\"4jPsO\",\"24.ea1906ea.js\",\"jDjSj\",\"16.0f9c0dbd.js\",\"8059b\",\"16.77f9d828.js\",\"3wmvj\",\"16.6efd8621.js\",\"hPalR\",\"16.782a40c1.js\",\"ijPJo\",\"spreadsheet.8bd9df3a.js\",\"fJtJG\",\"CommentsPanelFilterMenu.cff7e679.js\",\"hXXVg\",\"CommentEditor.74ebabf2.js\",\"b0QMY\",\"ConversationAssistant.00242d40.js\",\"dTZ5q\",\"ConversationAssistant.ffab4368.js\",\"6XaQi\",\"post-office-placement-remote.0dad62a4.js\",\"fHo9c\",\"post-office-placement-remote.1a87004c.js\",\"8e9ys\",\"post-office-placement-remote.runtime.4b4c454e.js\",\"5InDs\",\"post-office-placement-remote.a1cd91fe.js\",\"8e9ys\",\"post-office-placement-remote.runtime.4b4c454e.js\",\"397zr\",\"conversation-assistant-auto-suggest.fdb67ec1.js\",\"bWQZc\",\"3p-product-configs.77865c4f.js\",\"iqTGf\",\"GoalPanel.21b9bcca.js\",\"8sxKt\",\"definition-popup-content.ad479671.js\",\"c4B8Z\",\"ai-feedback-flags.137115f6.js\",\"lb9xb\",\"smart-card.b5fd8b54.js\",\"7WlwZ\",\"embedCard.0a2e9741.js\",\"fPDs0\",\"Rovo.e24f6f93.svg\",\"EfTik\",\"hoverCard.2943a747.js\",\"dYtBN\",\"page-live-doc.741a4505.js\",\"hv4mn\",\"modal.fe109fa9.js\",\"ht5OT\",\"RelatedLinksModal.runtime.d5f3be7c.js\",\"6PtxN\",\"cs.4af6da41.js\",\"8RKtn\",\"da.00cc494f.js\",\"fCIoO\",\"de.feb55cf0.js\",\"1geBW\",\"es.2b9a509c.js\",\"5WU5D\",\"et.c12c2abb.js\",\"i1Uow\",\"fi.577f953a.js\",\"3ZuKT\",\"fr.6da7024a.js\",\"5nJlY\",\"hu.3d953190.js\",\"Uq5C2\",\"it.d747a7e7.js\",\"9TzAL\",\"ja.6cac578c.js\",\"oPAjm\",\"ko.e5176471.js\",\"3fvcK\",\"nb.cf4f3e33.js\",\"iMYDs\",\"nl.0646b6ed.js\",\"jPHqC\",\"pl.7e10aa61.js\",\"3saM6\",\"pt_BR.2e845e69.js\",\"4hCdo\",\"pt_PT.3585f16f.js\",\"78gs3\",\"ru.6f4b63fe.js\",\"2XhMA\",\"sk.9b031399.js\",\"f7Egw\",\"sv.567af81d.js\",\"aiZUj\",\"tr.5656666a.js\",\"6rH3p\",\"th.f0261be3.js\",\"lS1VG\",\"uk.fe1da325.js\",\"fFbe4\",\"vi.32dd8df9.js\",\"7JTjB\",\"zh_TW.3a48b1fe.js\",\"dMjyc\",\"zh.37507780.js\",\"cPSQq\",\"renderer.b33be1bd.js\",\"9wbwa\",\"calendar-dark.a0ed3c18.svg\",\"edV1v\",\"calendar-light.caa4677f.svg\",\"5P10P\",\"location-dark.395fc7dc.svg\",\"1jWRt\",\"location-light.9d9cfd0a.svg\",\"bGCo4\",\"definition-popup-content.e18a8b7a.js\",\"fw9bs\",\"error-state-image.823f6961.png\",\"855o0\",\"component-lazy.runtime.6c634bba.js\",\"8Vm0B\",\"FullPageEditorComponent.runtime.66f7a98d.js\",\"dmXVq\",\"FullPageEditorComponent.runtime.c1d87e93.js\",\"BgBDS\",\"Racecar.f378b1ee.svg\",\"dwffN\",\"GlobalCreateContentPopoverMenu.e7a55ec5.js\",\"aDPqY\",\"ContextualCreateContentPopoverMenu.69a7cc5c.js\",\"3fgvt\",\"LazyTrigger.b1bf8925.js\",\"3VpLA\",\"initLoomSDK.53db4ac1.js\",\"4byV5\",\"is-supported.c869d210.js\",\"lwKXH\",\"is-supported.7a02a63d.js\",\"btYwu\",\"esm.63f46ef7.js\",\"fisfU\",\"video-play-overlay.0278a0bb.js\",\"wIOhQ\",\"esm.f6c7f163.js\",\"9LQGG\",\"close.f1edfb26.js\",\"lLK0D\",\"video-pause-overlay.bf3f58b5.js\",\"4drdS\",\"paint-palette.c083dcd8.js\",\"jle6Z\",\"premium.3f265b33.js\",\"xvDzM\",\"success.1bcc5fc4.js\",\"SqT67\",\"screen.3360fd1f.js\",\"a3Uq6\",\"esm.8d511208.js\",\"8UcgD\",\"UpdateComposer.336c5433.js\",\"2NjlT\",\"loom.feab0a0d.js\",\"e1fGs\",\"utils.4c418040.js\",\"ixLhb\",\"PopupContent.085f1823.js\",\"4KTzp\",\"PopupContent.98750c90.js\",\"eZu0L\",\"goal.2dc598fd.js\",\"l8LQp\",\"data-number.9bfeb2b4.js\",\"2XikM\",\"ProfileCard.17110e57.js\",\"aQwJX\",\"GoalPanel.c363ff0c.js\",\"9ZnhG\",\"th.71647b0c.js\",\"4Tiff\",\"uk.918f46f0.js\",\"iz8ME\",\"vi.6f47ac80.js\",\"1Pok1\",\"key-result.3e2e8c95.js\",\"jtcRz\",\"objective.9e034c80.js\",\"a2LRh\",\"goal.4005f323.js\",\"46t5f\",\"cs.b5c2f8ef.js\",\"1YqfS\",\"da.dec86820.js\",\"9DYyx\",\"de.0975f875.js\",\"42ZJx\",\"en_GB.42eb3fdf.js\",\"jtt0C\",\"en_ZZ.210dd49e.js\",\"3vk3N\",\"es.9d643b6c.js\",\"hbGGN\",\"fi.81699f73.js\",\"dopc8\",\"fr.66db395c.js\",\"9RJgs\",\"hu.b5f919fe.js\",\"jo6RJ\",\"it.ae2f310f.js\",\"lKoae\",\"ja.21ce32c5.js\",\"1MIK8\",\"ko.968e8d38.js\",\"jh74O\",\"nb.5ff82dfe.js\",\"alBoB\",\"nl.259bc702.js\",\"fwQyo\",\"pl.e3764686.js\",\"jnFv5\",\"pt_BR.30765a68.js\",\"3wEVm\",\"ru.7c664ec4.js\",\"1AYDD\",\"sv.767c47fe.js\",\"503rY\",\"th.c8936f87.js\",\"h5gGf\",\"tr.bb779b1f.js\",\"kgjXg\",\"uk.73ab38d0.js\",\"jvpmI\",\"vi.e3c94a6d.js\",\"8ajSg\",\"zh_TW.9c58e225.js\",\"cz5Vg\",\"zh.88b09721.js\",\"g55vn\",\"team.c77c3984.js\",\"jvHRs\",\"team-preview-panel.04032fb3.js\",\"hjuEj\",\"project.e0e16033.js\",\"28VDA\",\"ProjectLinkerGoal.67484b07.js\",\"m7vj2\",\"provider.f89b8d08.js\",\"cs0k1\",\"th.bc465272.js\",\"gce4m\",\"uk.ff4881ca.js\",\"eFwGF\",\"vi.52b3bee6.js\",\"hLVzM\",\"suggested-edit.9edafd06.js\",\"4Jbf1\",\"sprint.69e64865.js\",\"k97iL\",\"focus-area.6dcaf5d4.js\",\"5BMnr\",\"calendar-plus.435c4b76.js\",\"8HgfY\",\"TeamProfileCardEntryPoint.78fbc0bb.js\",\"3SULx\",\"LazyTrigger.4b647ca8.js\",\"4XUbE\",\"universal-create.08d30853.js\",\"beE2d\",\"NativeCollabComponent.df992ca5.js\",\"1yVM6\",\"UpgradeEditionButton.82664418.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.f534cc28.js\",\"6XCf4\",\"LearnMoreButton.0e904e1d.js\",\"4TxwY\",\"ShareButton.000f81c4.js\",\"jbxHq\",\"CommentsPanelFilterMenu.c3a0b89c.js\",\"h7P2N\",\"CommentEditor.09d3235d.js\",\"np2ZB\",\"NonMasteredUserModal.dbeb8427.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"hU8F9\",\"LoomCrossSellPopupCardImageNewVisual_Light.55587eef.png\",\"fTxJf\",\"LoomCrossSellPopupCardImageNewVisual_Dark.c1c1769c.png\",\"c0kqt\",\"TreeBottomCreateButton.bd782349.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.9b8d813d.js\",\"i1TuF\",\"cs.2190cb07.js\",\"eEPT4\",\"da.02eaca38.js\",\"gkfGT\",\"de.90355bf8.js\",\"6kSRw\",\"en.32193a4b.js\",\"2dFTF\",\"en_GB.09598cb2.js\",\"auo6z\",\"en_ZZ.f14ca7c2.js\",\"685rk\",\"es.8fa0593c.js\",\"fp6pG\",\"fi.71fd59df.js\",\"6bt8l\",\"fr.40c5717d.js\",\"jjvsl\",\"hu.50ccd7da.js\",\"bAfbH\",\"it.e0e7a6ba.js\",\"5Q9X0\",\"ja.2dfec41f.js\",\"ePkyJ\",\"ko.0b1ec89d.js\",\"hpdFn\",\"nb.b2e768d2.js\",\"8qW90\",\"nl.7f781ad8.js\",\"a1OSV\",\"pl.ca25a045.js\",\"8AvOI\",\"pt_BR.eb536358.js\",\"jxu37\",\"ru.3bbb4cd9.js\",\"10YQF\",\"sv.b02b2c4a.js\",\"daBgp\",\"tr.1172519d.js\",\"bI6N0\",\"th.b72c3249.js\",\"3Qhls\",\"uk.c5a9160e.js\",\"dgXIC\",\"vi.98dce50e.js\",\"jh4hi\",\"zh_TW.79a7157d.js\",\"2AL0H\",\"zh.29b1c23a.js\",\"kG8pF\",\"ViewPage.dfeebb8c.js\",\"b8QJ8\",\"UpdateComposer.3986980e.js\",\"36QeB\",\"component-lazy.264f7cb1.js\",\"8YSo7\",\"CommentsPanelFilterMenu.f18c54e3.js\",\"8PPsf\",\"FullPageEditorComponent.c7ce9601.js\",\"clQc9\",\"FullPageEditorComponent.runtime.7f188adb.js\",\"8cF7a\",\"ContextualCreateContentPopoverMenu.40184479.js\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"5TJ4V\",\"WhiteboardExperimentSpotlightImage.49c94c1b.svg\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"eJgN2\",\"WhiteboardsPaywallV2.5dd554e3.svg\",\"dk0NC\",\"WhiteboardsPaywallDarkV2.e9c25635.svg\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"brItY\",\"CreateWithRovoSpotlightAnimationDark.886221cf.gif\",\"jb5iT\",\"CreateWithRovoSpotlightAnimationLight.1a1df728.gif\",\"4l6Se\",\"ContextualCreateContentPopoverMenu.73dcbf72.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.f534cc28.js\",\"clQc9\",\"FullPageEditorComponent.runtime.7f188adb.js\",\"clpSH\",\"PageTreeQuickActions.eb8ff93a.js\",\"13PnU\",\"QuickActionsContent.c86aa1bb.js\",\"bunf9\",\"Controller.deaf3099.js\",\"764nc\",\"tooltip.39ce4f8b.js\",\"faXeM\",\"main.7d3406f2.js\",\"7eOUa\",\"main.ffeda151.js\",\"9zjWJ\",\"main.a0c15c17.js\",\"cwwPf\",\"main.bcd96707.js\",\"3a4K1\",\"main.0fcd82ca.js\",\"9J4KV\",\"cs.b9f01e7d.js\",\"8Y9JE\",\"da.18219947.js\",\"gWrRN\",\"de.fc8f0041.js\",\"irKcy\",\"en.d92e0384.js\",\"1aghR\",\"en_GB.73f26b83.js\",\"3jFnE\",\"en_ZZ.47fee1a1.js\",\"11Khz\",\"es.d3b6a214.js\",\"ap0LY\",\"et.e75ca3b6.js\",\"34Ma8\",\"fi.c1597c2f.js\",\"lBwDa\",\"fr.14ed1e6e.js\",\"32Pvr\",\"hu.9601580b.js\",\"b7bFd\",\"is.d9772209.js\",\"6h8Ae\",\"it.a294623d.js\",\"dW8Ws\",\"ja.67927497.js\",\"fJZdm\",\"ko.04c43bb8.js\",\"kfTIE\",\"nb.fa1d7c5f.js\",\"b8M9e\",\"nl.fc5eecfe.js\",\"jMchi\",\"pl.702acc92.js\",\"2xsmF\",\"pt_BR.0fb04576.js\",\"hHyCx\",\"pt_PT.77e6008a.js\",\"gw4Pw\",\"ro.7a5f0e93.js\",\"8rhcn\",\"ru.4bfdbf4c.js\",\"fh5Vk\",\"sk.173f2352.js\",\"aP4eD\",\"sv.7507ae81.js\",\"aJWAE\",\"th.4a054693.js\",\"b96A2\",\"tr.28f66bf7.js\",\"g0ukK\",\"uk.995a185c.js\",\"8DuKk\",\"vi.b98f33f3.js\",\"5aSRq\",\"zh_TW.8ab090b6.js\",\"eQT38\",\"zh.015b15d5.js\",\"fYFVU\",\"UpflowV2ExperimentErrorBoundary.c4c6d6bb.js\",\"c4Kdp\",\"GeneralAccessLevelSelector.5a6ec273.js\",\"eRrWU\",\"EndUserRequestUpgradeModal.d53d6eca.js\",\"kiGNy\",\"render.a63c9358.js\",\"bjfAh\",\"EndUserRequestUpgradeModal.9b7539f5.js\",\"bGfxQ\",\"error-visual-dark.a52399eb.png\",\"djGcB\",\"error-visual-light.8a0abe86.png\",\"8kpTd\",\"visual-dark.589bc948.png\",\"aPOi6\",\"visual-light.1c3bfa82.png\",\"k0hwN\",\"ShareToSlack.0ccacded.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"7BRMY\",\"TeamProfileCardEntryPoint.3fa70cbc.js\",\"7NSxP\",\"TeamProfileCardEntryPoint.0cb24693.js\",\"1gGaH\",\"EntryPointComponent.8d6305bb.js\",\"9gtXW\",\"EntryPointComponent.dee2d27d.js\",\"9evbL\",\"TeamAppTile.265b8d3b.svg\",\"lDkw4\",\"TeamProfileCardEntryPoint.e133a25c.js\",\"9yT7Z\",\"ConfluenceIcon.3b027e05.svg\",\"8UdN7\",\"JiraIcon.a06d5f95.svg\",\"2Wuv3\",\"JiraProjectDiscovery.556db745.svg\",\"Q5mZp\",\"JiraServiceManagement.0b0134a3.svg\",\"32rDq\",\"LoomIcon.8c0f7a38.svg\",\"hfT7k\",\"disconnect-dialog.b492d934.js\",\"2cvOU\",\"NoProductAccess.a65d0283.svg\",\"85liN\",\"InspectPermissionsDialog.77ebd0e9.js\",\"iQ0Jm\",\"SmartButtonConfigPanel.ef9d861c.js\",\"QcHuP\",\"InspectPermissionsDialog.e49daab0.js\",\"aX0L0\",\"InspectPermissionsDialog.2b4283a8.js\",\"dMOc8\",\"projection-screen.1d8acbb5.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"13QWg\",\"in-trial-feature-gates-banner.0a54cccc.js\",\"dGk3x\",\"GlobalFeedbackCollector.2f9518c8.js\",\"8Yk54\",\"DarkEmptyState.b237e8cb.png\",\"dEQI1\",\"LightEmptyState.1b72e55d.png\",\"2i7Iv\",\"DarkError.d13c9c5b.png\",\"17ygR\",\"LightError.5b516166.png\",\"36rXN\",\"MovePageDialog.bc16c0fc.js\",\"6FaFk\",\"ContentTreeSearchStates.e1988b8c.js\",\"7ZHrh\",\"SearchNoResultLight.8777776b.svg\",\"gaG2b\",\"SearchNoResultDark.50b7a17f.svg\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.cb954ff5.js\",\"h4Nf7\",\"ExternalUserLozenge.6c39b83e.js\",\"hA2SB\",\"GroupAndUserItem.2e48dc9d.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"gryT8\",\"ShareButton.530794ee.js\",\"dqkUL\",\"GroupAndUserItem.aca3c3de.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"PNyg1\",\"InlineRename.0981fdd6.js\",\"dlm6q\",\"InlineRename.b91d09b9.js\",\"5zDuS\",\"NativeCollabComponent.97d6b228.js\",\"19uFC\",\"pages.d69df670.js\",\"4mgLr\",\"node.a3f57a67.js\",\"lVcuZ\",\"MovePageDialog.6839634b.js\",\"3L1uC\",\"PageTreeErrorComponent.423edfa6.js\",\"ewwba\",\"PageTreeEmptyComponent.848e20ca.js\",\"dviIw\",\"CollapsibleSection.c762c0bf.js\",\"dhqJV\",\"FooterCreateButtons.fbf78d6d.js\",\"67Pvd\",\"ContentTreeOnboarding.268c404c.js\",\"e19Zv\",\"LiveDocsIconTile.eebb3e48.js\",\"dek7I\",\"page-live-doc.228e3586.js\",\"d1QkY\",\"TreeBottomCreateButton.29c2467c.js\",\"f9QHk\",\"TreeMonitor.8c51de24.js\",\"fnoJZ\",\"HomepageIcon.f41b8d55.js\",\"6gau7\",\"DraftLozenge.af187a33.js\",\"5ppK3\",\"MovePageDialog.78fe9a39.js\",\"e4XZ1\",\"MovePageDialog.21cd0c5f.js\",\"cPaXL\",\"ArchiveUpsellDialog.c0811781.js\",\"3uux1\",\"ArchivePagesLoader.b1fa6903.js\",\"8qpSy\",\"ErrorSectionMessage.4b35930e.js\",\"i5EJc\",\"ErrorComponent.8143cea8.js\",\"2wJza\",\"ErrorGraphic.784b3ce3.svg\",\"1u9sS\",\"ArchivePagesLoader.201e83ec.js\",\"in6Mc\",\"NoChildrenBullet.407634ad.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.635c3066.js\",\"4xZ5N\",\"PageQuickActionAutomationMenu.3d2b3d50.js\",\"aOpoD\",\"empty-automation-list.9c7d0496.png\",\"awXdT\",\"error.b6351f9e.svg\",\"kSBog\",\"PageQuickActionAutomationMenu.ac22de8c.js\",\"cDlXo\",\"cs.bb7b2398.js\",\"aGqxI\",\"da.2f2eb656.js\",\"8DMgV\",\"de.d2d66f21.js\",\"3lwWF\",\"en_GB.ef04196d.js\",\"6n44e\",\"en_ZZ.0706863b.js\",\"i2lSs\",\"es.cfb981b6.js\",\"cddHY\",\"fi.b34be9f5.js\",\"2nFnK\",\"fr.9414a49e.js\",\"iMEy4\",\"hu.19dd1006.js\",\"79NWg\",\"it.5b76b6c9.js\",\"dn37Z\",\"ja.198e5ad1.js\",\"2y34H\",\"ko.a4730b26.js\",\"g8Vga\",\"nb.256e2e51.js\",\"fw5Rx\",\"nl.7df68bde.js\",\"cqxYX\",\"pl.48257922.js\",\"3Wq1f\",\"pt_BR.b0cab9c2.js\",\"ePmaE\",\"ru.f24df80d.js\",\"2PbJR\",\"sv.9362d1ff.js\",\"04oVB\",\"tr.2426a00f.js\",\"7lf25\",\"zh_TW.3e778977.js\",\"csVFP\",\"zh.453474a1.js\",\"9YGIy\",\"DeleteNestedPagesAction.3f0b6ee0.js\",\"iomzR\",\"DeletePageDialog.c67098ed.js\",\"p4ay7\",\"CopyPageTreeContainer.5ebd34d7.js\",\"aiU5r\",\"CopyPageDialogContainer.a5dabf0d.js\",\"aoUod\",\"MoveBlogModal.7963e63e.js\",\"bg5OF\",\"shortcut.6dd1c4df.js\",\"fLZBc\",\"QuickActionsContent.40d8dce6.js\",\"4yUSc\",\"PremiumLozenge.3729de1f.js\",\"ePA5l\",\"Lozenge.b5fc2aaf.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"kyxdN\",\"EditSpaceLogo.0ead497c.js\",\"gRwHT\",\"EditSpaceLogoComponent.b43ef85e.js\",\"dJhDI\",\"Upload.41b8806c.svg\",\"7t2Ec\",\"EditSpaceLogoGallery.5cceb9fd.js\",\"fsikk\",\"cardWithMediaClient.3feeedb7.js\",\"4o7bO\",\"CreateSpaceDrawer.8a8ee04d.js\",\"860dT\",\"SpaceHeaderExCoOnboarding.d3455196.js\",\"9H1r6\",\"GraphBarIcon.8122a900.js\",\"19Ali\",\"GridIcon.bf4f9a0b.js\",\"hI11K\",\"AutomationNavigation.9b5b5ba3.js\",\"4skpM\",\"AutomationChangeBoarding.966c38bc.js\",\"8xPy6\",\"SmartButtonIllustration.b4b7c8dc.png\",\"fbDZw\",\"QuestionsNavigation.3c23fbac.js\",\"c0OU0\",\"QuestionsIcon.2b9be2c0.js\",\"7Qxu7\",\"TeamCalendarNavigation.cce4a09e.js\",\"aZ9pO\",\"CalendarIcon.852bd13f.js\",\"5DqrE\",\"BulkToolsNavigation.321dc275.js\",\"hHrTM\",\"edit-bulk.40121784.js\",\"klGUa\",\"ErrorView.603b0f1b.js\",\"j0beU\",\"EyeStrike.801ddb27.svg\",\"eWlhh\",\"Nav3SpaceApps.7810ea9b.js\",\"hs6o8\",\"SpaceAppsConfiguration.cda31508.js\",\"hxqz2\",\"Nav3SpaceNavigationContent.ca326c29.js\",\"19XET\",\"render.86d649d0.js\",\"j4CTh\",\"tasks.4e573bd1.js\",\"8FnXP\",\"PageLayout.ecb330d7.js\",\"iTImB\",\"heart.91f6fb22.svg\",\"bl22g\",\"notes.c9738615.png\",\"dAcu4\",\"ai-notes-icon.f866806e.svg\",\"lguNj\",\"chrome-icon.40414d4b.svg\",\"c4pCE\",\"rovo-icon.a638efdd.svg\",\"l5cKN\",\"twc-app-tiles.b4f04c82.svg\",\"dC9p7\",\"Nav3SpaceNavigationContent.4ecbd0d8.js\",\"1NnjK\",\"ShortcutsSection.4f25bf50.js\",\"aBvTF\",\"ShortcutsDragContainer.1cd93730.js\",\"kNV5Y\",\"blog.69c05569.js\",\"kDqHr\",\"file-icon.22bc916f.js\",\"4HZlX\",\"chart-bar-icon.df50cf8f.js\",\"7jSfd\",\"list-bullet-icon.cb0c6e79.js\",\"aOY32\",\"branch.0ac931bd.js\",\"6fQco\",\"commit.3833a19b.js\",\"1MWOL\",\"pull-request.9d87c39d.js\",\"9wPDc\",\"code.9ea99454.js\",\"lm9Lt\",\"changes.0378d48e.js\",\"4S1SF\",\"incident.df893528.js\",\"XZauT\",\"problem.f9b4e92f.js\",\"9aQIt\",\"subtask.9dbed38a.js\",\"jiFtb\",\"epic.d7a148ac.js\",\"4RbVd\",\"database.49ae4296.js\",\"bGpE6\",\"whiteboard.f2367cfe.js\",\"eBRUf\",\"GoalPanel.dc2c554a.js\",\"jg5LT\",\"root-component.62d9da8b.js\",\"kBLei\",\"PersistentCollapsibleSection.b4a288f5.js\",\"5TCys\",\"SpaceViews.65f25d46.js\",\"aCG0y\",\"SpaceViewsErrors.66ea6c83.js\",\"5qLBt\",\"SearchNoResultLight.8777776b.svg\",\"6KUsM\",\"SearchNoResultDark.50b7a17f.svg\",\"1TYNY\",\"SpaceViewsCurrentViewIndicator.40b7808f.js\",\"guX1n\",\"ViewMoreButton.a28c4578.js\",\"kJLy8\",\"SpaceViewsList.021f456c.js\",\"6gmSt\",\"PagesItemActions.51cdb0e6.js\",\"3HpiM\",\"BulkActionsChangeboardingSpotlightInner.a2329652.js\",\"3YKnT\",\"bulkActionsChangeboardingSpotlightImage.9c36fbc8.svg\",\"fC3D2\",\"SpaceViewsMenu.6d03d318.js\",\"cWvhX\",\"PageOwnershipByLineWithContributorsDropdownContent.5872caca.js\",\"eQlG4\",\"ContentTreeSearch.d4cc15a7.js\",\"cQVtz\",\"SpaceHoverPageCard.ef97d4fb.js\",\"gLGsg\",\"FullPageEditorComponent.36b7777b.js\",\"eBqZ6\",\"EndOfPageRecommendation.be6a2903.js\",\"19QIS\",\"CommentsPanelFilterMenu.57d29505.js\",\"kv7hL\",\"EndOfPageRecommendation.cda37af4.js\",\"hcwNq\",\"EndOfPageRecommendation.runtime.37693086.js\",\"hcwNq\",\"EndOfPageRecommendation.runtime.37693086.js\",\"hDNUK\",\"BlogTree.e279da01.js\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.b3f7f319.js\",\"7Ni3R\",\"GuestOnboardingModal.a9dbe095.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"6sGtZ\",\"render.b7ccb0f0.js\",\"hFtKc\",\"SpaceNavigationContent.46c4e9e7.js\",\"ci2h5\",\"Spaces.5611c4bd.gif\",\"gEZwe\",\"Spaces-dark.4ceec6cd.gif\",\"3XEdh\",\"Spaces-placeholder.5b3f2999.png\",\"7SqAi\",\"Spaces-placeholder-dark.1c1d1b34.png\",\"c08ou\",\"CalendarsLink.1b3b019d.js\",\"8uhuz\",\"QuestionsLink.929d4408.js\",\"kZjBp\",\"SpaceApps.7f9c7e17.js\",\"69bC9\",\"ContentTypesHeader.586c64ff.js\",\"e2ujj\",\"eye-open-filled.c4b25411.js\",\"fSc0b\",\"Nav4CollapseReminderSpotlight.2efa3ca4.js\",\"3WCRn\",\"NewKeyboardShortcutsDialog.33580d0d.js\",\"4AAsh\",\"AddPersonalSpaceDialog.219a2f75.js\",\"cbb8R\",\"megaphone.ea49a10b.svg\",\"7enLt\",\"clipboard.6bbe40ee.svg\",\"irkOO\",\"nameTag.1bdcf89f.svg\",\"8H6xE\",\"EditionAwareness.4ec6f316.js\",\"1AVLS\",\"automation-free-limit-modal.54e48584.js\",\"1Bzn5\",\"breached-icon-dark-mode.c76c5af4.svg\",\"4li5B\",\"breached-icon.604210d1.svg\",\"5Hb8k\",\"gestural-line-dark-mode.0238cd16.svg\",\"fKxeV\",\"gestural-line.c0eb7c9f.svg\",\"7REXs\",\"automation-danger-icon.9e7c0e3a.svg\",\"7NqPm\",\"automation-warning-icon.0d3ef917.svg\",\"aMOuo\",\"collection-add-payment-details-popup.0cbb019e.js\",\"9gHNl\",\"twc-popup-background-dark.0f701da2.svg\",\"2l8ah\",\"twc-popup-background-light.30b1cc68.svg\",\"99wAt\",\"collection-change-plan-popup.3ef40e35.js\",\"4I0kP\",\"end-user-request-modal.061c1a48.js\",\"dGvEg\",\"feature-onboarding-modal.1568870a.js\",\"39fCS\",\"background-dark.a3b81b65.svg\",\"hlyBg\",\"background.335ae0da.svg\",\"ltJpU\",\"blue-box.4faddac8.svg\",\"lq3Sl\",\"free-choose-your-edition-modal.be90f685.js\",\"iI6Q4\",\"free-to-standard-modal.ef677f13.js\",\"bpZy3\",\"user-brand-dark.2dd77a4f.svg\",\"4B6ye\",\"user-brand-light.f1d0cd78.svg\",\"g2AXX\",\"user-gray-dark.8d7964d6.svg\",\"30svi\",\"user-gray-light.4df874b4.svg\",\"2zp5o\",\"background-dark.46d9946a.svg\",\"eGZ7X\",\"background-light.c76a8e81.svg\",\"2kbQr\",\"discovery-background-dark.73b58e40.svg\",\"8LjMq\",\"discovery-background-light.e5db6720.svg\",\"7qqQA\",\"gestural-line-dark.5fb5d96c.svg\",\"jmfnZ\",\"gestural-line.8591d4ac.svg\",\"jr06u\",\"jsw-add-people.17946c9a.svg\",\"jTG5T\",\"jsw-increased-storage-limits.b8a08bb1.svg\",\"iNU7h\",\"increased-storage-limits.a7321574.svg\",\"15Vzp\",\"unlimited-creators.3de71904.svg\",\"i0M9R\",\"help-desk-attachments-darkmode.a8bd959e.svg\",\"9zK71\",\"help-desk-attachments.138601ac.svg\",\"2hde5\",\"jsm-service-collection-add-people-darkmode.290a8179.svg\",\"j99t9\",\"jsm-service-collection-add-people.8f940b7d.svg\",\"anVlQ\",\"jsm-increased-storage-limits.21bb9c1c.svg\",\"cYQGZ\",\"unlimited-agents.743019a8.svg\",\"cHQ50\",\"location.970afe87.js\",\"aE4di\",\"phone.b88e8f90.js\",\"aKXvR\",\"payment-details-popup.39f5a4c1.js\",\"kwFai\",\"background.b3afa1bc.svg\",\"cDKlY\",\"plan-selection-page-modal.a552a287.js\",\"4JtX7\",\"premium-add-payment-modal.d47afdeb.js\",\"luoSj\",\"jpd-hierarchies.c6150f5d.svg\",\"73HLv\",\"jpd-roadmap.f097129b.svg\",\"lhoQv\",\"jpd-view-restrictions.3427d350.svg\",\"ki3nq\",\"premium-popup.9d0546bd.js\",\"czatF\",\"premiumPopupHeader-Dark.8772bafb.svg\",\"8oiny\",\"premiumPopupHeader-Light.587e53c0.svg\",\"7YE3I\",\"reverse-trial-popup.be1e0fca.js\",\"iFA9H\",\"special-offer-sixty-modal.3c9bc47a.js\",\"3KKo2\",\"background.cfd6bca5.svg\",\"1j7i8\",\"gestural-line-signal-4.2ed74c75.svg\",\"abLmz\",\"gestural-line-star-4.7814368e.svg\",\"kyUks\",\"radio-unchecked.a80b0bc5.js\",\"3opZo\",\"radio-checked.bfe4f2a4.js\",\"eCMUX\",\"standard-add-payment-modal.7f8cce37.js\",\"lmoGI\",\"confluence-add-people.95d7cd0c.png\",\"1JrC5\",\"confluence-guest-access.0a003025.png\",\"cfLGc\",\"confluence-page-insights.548fcd17.png\",\"3DLtA\",\"confluence-page-restrictions.6ddf91dd.png\",\"dp0gI\",\"attachments.a7321574.svg\",\"7XFVr\",\"help-desk-attachements.21bb9c1c.svg\",\"7RlGN\",\"jpd-add-people.3de71904.svg\",\"4jaDc\",\"jsm-add-people.743019a8.svg\",\"kVhCr\",\"jsw-add-people.17946c9a.svg\",\"lLln8\",\"storage-hard-limit-modal.4073fb6a.js\",\"aCxGF\",\"storage-limit-breached-icon-dark-mode.c76c5af4.svg\",\"9WLSk\",\"storage-limit-breached-icon.604210d1.svg\",\"7hYpO\",\"storage-limit-danger-icon.9e7c0e3a.svg\",\"60S8F\",\"PremiumTrialOnboardingSpotlight.21e8b783.js\",\"dTz74\",\"RtNeutralMessagingSuppressComponentsHoc.c46470e5.js\",\"d5wRy\",\"Spotlight-pto2-dark.d9bc480a.svg\",\"fZEhl\",\"Spotlight-pto2-light.bfab086d.svg\",\"2E7bn\",\"Spotlight-pto2-dark-295x135.339d09e4.svg\",\"d3Q4u\",\"Spotlight-pto2-light-295x135.c27a4490.svg\",\"5CaYW\",\"video-play.924440ef.js\",\"2OWSd\",\"PremiumOnboarding.2c48c595.js\",\"78YgQ\",\"Illustration.bc0cbd7b.svg\",\"bKgRA\",\"Illustration.bc0cbd7b.svg\",\"1Ldmy\",\"FullPageEditorComponent.86d5781b.js\",\"jTort\",\"FullPageEditorComponent.runtime.8906f162.js\",\"jTort\",\"FullPageEditorComponent.runtime.8906f162.js\",\"4xmPF\",\"sha256SimpleHasher.20e93cc7.js\",\"77ceh\",\"definition-popup-content.5c1dd0ac.js\",\"g9CVe\",\"mention.acd49770.js\",\"h9Ed7\",\"GoalPanel.41ac6cb0.js\",\"lVO3w\",\"ProjectPanel.3aa1dcb3.js\",\"jnkIk\",\"TeamProfileCard.98926888.js\",\"3l6zb\",\"ProjectPanel.92b86138.js\",\"gWfLJ\",\"team-preview-panel.1101eee2.js\",\"nRE0L\",\"definition-popup-content.19bbc302.js\",\"awWN9\",\"definition-popup-content.52bf5091.js\",\"6mHrv\",\"definition-popup-content.24c2b797.js\",\"dChec\",\"spotlight.a73f587b.js\",\"j5GZH\",\"InvalidExtension.ae510e92.js\",\"7EJ3Q\",\"PageLayout.d7d18188.js\",\"49e27\",\"PageLayout.48f1ee7d.js\",\"6tsCm\",\"ContentTypesHeader.e13b4eb2.js\",\"b6JBs\",\"CompanyHubBreadcrumbs.69688ece.js\",\"lpcEN\",\"ChangeHubNameDialog.3f78f5ad.js\",\"70fET\",\"hub-hero-image.d6790ccb.png\",\"1GyAj\",\"BreadcrumbsDropdownContent.dd938ada.js\",\"hHYS0\",\"ModernizedBreadcrumbsIndentIcon.2b5f9d84.js\",\"3pn87\",\"PageLayout.4e256cb2.js\",\"avZlC\",\"BannerContainer.9d4ae978.js\",\"9mi9f\",\"BannerSpacer.3168d6ed.js\",\"kiqoj\",\"SuperAdminBanner.fb5aefec.js\",\"jE5XU\",\"SatisfactionSurveyFlag.aaeec784.js\",\"f8xBv\",\"SatisfactionSurveyComponent.1aa54f71.js\",\"4csuu\",\"terrible.43df9387.svg\",\"ezTnP\",\"bad.1f02aedc.svg\",\"lKYkZ\",\"okay.fd894a28.svg\",\"eOIaN\",\"great.e17ca230.svg\",\"c1rvV\",\"amazing.0fceeb3a.svg\",\"fbsPn\",\"AdminAnnouncementBanner.38799ecd.js\",\"2Mq3f\",\"megaphone.8faf2592.js\",\"eIzhm\",\"AdminAnnouncementBanner.91385169.js\",\"cjDIz\",\"GracePeriodBanner.39149729.js\",\"3Xhte\",\"UpFlowCommerceRouter.2c4839f5.js\",\"9ET5T\",\"GracePeriodBanner.190f491c.js\",\"4zlcK\",\"avoid-deactivation-data-modal.b314630b.js\",\"jfplD\",\"GracePeriodBanner.8eca86e0.js\",\"4uVag\",\"StorageEnforcementBanner.92fcbaf3.js\",\"cGZdO\",\"PlanConsentDeepLink.f74e54e5.js\",\"hmjlF\",\"ConsentBannerWrapper.1fd82e66.js\",\"9FU4d\",\"browser-storage-controls.d63ab764.js\",\"gCbq8\",\"cs.a209aa14.js\",\"TR24h\",\"da.52144f35.js\",\"NfUyB\",\"de.189b802b.js\",\"4v21d\",\"en_GB.58bcc852.js\",\"4D2WV\",\"en_ZZ.07b6b0f2.js\",\"gSwbJ\",\"es.27061460.js\",\"chaHI\",\"fi.f05d4dc5.js\",\"kBpIt\",\"fr.d4774d68.js\",\"dPeMl\",\"hu.9a5436ee.js\",\"4PHEa\",\"it.8260474e.js\",\"CGYMd\",\"ja.514cf297.js\",\"fGpBg\",\"ko.09d46e0e.js\",\"cgWNw\",\"nb.593f98f0.js\",\"aUP3I\",\"nl.9e24e59e.js\",\"bs4gz\",\"pl.e0577981.js\",\"gSXrz\",\"pt_BR.1efcd373.js\",\"aJd4I\",\"ru.b8c2b1b7.js\",\"gR7fm\",\"sv.07219ae9.js\",\"xDkFq\",\"th.be4d9bd0.js\",\"cV2OA\",\"tr.7e1ff419.js\",\"ehLR6\",\"uk.86f0ff8b.js\",\"lXmbw\",\"vi.43447bab.js\",\"jwfyA\",\"zh_TW.fa40865e.js\",\"6zOB9\",\"zh.d323a517.js\",\"7ETma\",\"BannerContainer.df04d1c8.js\",\"jryQt\",\"GlobalComponents.0aee7ad8.js\",\"lnKog\",\"main.b8dfa167.js\",\"2PePB\",\"main.3e62b69a.js\",\"aLGWB\",\"WaveformAnimation.27743507.js\",\"ivNGg\",\"GeneratingAnimation.1e1e5744.js\",\"hVPSr\",\"AudioBriefingSonicMark.b774c076.mp3\",\"atyNV\",\"CreateSpaceDrawer.6967c03d.js\",\"4fscz\",\"skyBackground.807308bc.svg\",\"jhQhN\",\"RovoAnnouncementSplashContainer.c7219c82.js\",\"br6Aw\",\"LightModeFrame1.88b5dbfe.gif\",\"1CT3s\",\"DarkModeFrame1.6ac03536.gif\",\"cTRon\",\"LightModeFrame2.b826bbb1.gif\",\"2zDRq\",\"DarkModeFrame2.efe28578.gif\",\"7W5z9\",\"LightModeFrame3.dbfb7a04.gif\",\"47RWT\",\"DarkModeFrame3.d087cb13.gif\",\"6aY84\",\"video-pause.9effbaae.js\",\"aIwO0\",\"cs.b6bf5a4f.js\",\"iwseV\",\"da.cc345e0b.js\",\"eh9w8\",\"de.421e2606.js\",\"3eWGu\",\"en_GB.f0cc3e02.js\",\"8jVst\",\"en_ZZ.ee5a9d54.js\",\"hNk7k\",\"es.37969e70.js\",\"arXo9\",\"fi.52e0791f.js\",\"yuLnu\",\"fr.c8d7a7dc.js\",\"2pQv8\",\"hu.761d60f0.js\",\"jGBo1\",\"it.06ced96f.js\",\"eUrwV\",\"ja.37031316.js\",\"2zgDh\",\"ko.93ad1760.js\",\"bETPT\",\"nb.0b9df19d.js\",\"ceBZg\",\"nl.a12ecbcf.js\",\"5STWe\",\"pl.fec15149.js\",\"EfE3i\",\"pt_BR.490404b4.js\",\"hFqXA\",\"ru.0864dcd6.js\",\"4ArgV\",\"sv.efec6fac.js\",\"28EDH\",\"tr.b47fcd7e.js\",\"k3mTs\",\"th.46a34475.js\",\"jJdZ4\",\"uk.7c54dc83.js\",\"eZRzs\",\"vi.fd024846.js\",\"bLQZ9\",\"zh_TW.50c11856.js\",\"e0E8p\",\"zh.6023ed27.js\",\"7rE1n\",\"msr-nudges.b5cc3713.js\",\"b2zon\",\"loom-cross-join-nudge.8c91c3ef.js\",\"ehu5c\",\"EndOfTrialModalContainer.e62cd5c0.js\",\"fkozR\",\"background-dark.46d9946a.svg\",\"3FECQ\",\"background-light.c76a8e81.svg\",\"doIPU\",\"gestural-line-dark.9e5d1ce8.svg\",\"dT0Nh\",\"gestural-line.93eaf758.svg\",\"cOOgy\",\"strike-through.539e2da9.svg\",\"bP6pn\",\"NthUserOrientationInner.29c0a7ef.js\",\"878st\",\"base-component.d7c4bf1f.js\",\"lAzPQ\",\"base-component.a66cda1c.js\",\"jJOfU\",\"ConfluenceStandardOfferAIModalRightSide.7551cf90.svg\",\"e1pCZ\",\"ConfluenceStandardOfferAIModalRightSideDark.4c810671.svg\",\"6xJuR\",\"base-component.1a2c5b84.js\",\"gmwfN\",\"ModernizeChangeboarding.f63b3bee.js\",\"iZkNL\",\"Modal.552beb50.js\",\"4jvyy\",\"play-button.f16ed914.png\",\"bSWox\",\"thumbnail-light.cbc485ab.png\",\"espuV\",\"thumbnail-dark.4c2a9461.png\",\"7VEEc\",\"whiteboards.5bac062b.svg\",\"1S5Y4\",\"rovo-ai.1a901dc7.svg\",\"dZyP8\",\"reactions-and-stickers.1f3b4ebe.svg\",\"8VWrF\",\"jira-work-items.11443501.svg\",\"55agv\",\"loom-videos.37a4452c.svg\",\"jGjVz\",\"whiteboards-dark.5a9dae19.svg\",\"j77CV\",\"rovo-ai-dark.ac54f515.svg\",\"33gHJ\",\"reactions-and-stickers-dark.fd611bb0.svg\",\"eRF5i\",\"jira-work-items-dark.f74ce1c2.svg\",\"crbaY\",\"loom-videos-dark.1afab585.svg\",\"31kOm\",\"nav4GlobalSpotlightImage.b0eee534.svg\",\"dW3gq\",\"nav4GlobalSpotlightImageDark.46829a6e.svg\",\"1aHOD\",\"nav4SpaceSpotlightImage.8dc1626b.svg\",\"huVSt\",\"nav4SpaceSpotlightImageDark.eeaa5b5d.svg\",\"iXULO\",\"LiveDocModalGif-light.2404511f.gif\",\"ff6Qm\",\"LiveDocModalGif-dark.64c94d68.gif\",\"li9sm\",\"MainButtons.19d92001.js\",\"8S7hU\",\"ContentWrapperSpotlightGIF-dark.bbe9839d.gif\",\"7P169\",\"ContentWrapperSpotlightGIF-light.9900190e.gif\",\"dj3mE\",\"ExperimentPlanSelectionModal.d56c2437.js\",\"3AFNb\",\"illustrationStandard.3fd561a4.svg\",\"c7qkT\",\"illustrationBestValue.d42ec92a.svg\",\"cYTMv\",\"illustrationBestValueDarkMode.4db8a5eb.svg\",\"eRZ4m\",\"illustrationStandardDarkMode.d9f68860.svg\",\"gs8si\",\"ConfluenceSmartCreationModalManager.eadb169d.js\",\"dIKKx\",\"StorageEnforcementFlags.56e3e320.js\",\"52dqm\",\"GracePeriodModal.aed78f87.js\",\"6sJUU\",\"GracePeriodModalComponent.9d9f0336.js\",\"gKiqN\",\"gracePeriodIllustrationDark.e34dd459.svg\",\"02fAA\",\"gracePeriodIllustrationLight.04bd67a4.svg\",\"gIOIL\",\"BlockCreateModal.1dbb5eeb.js\",\"fDkpP\",\"blockCreateIllustrationLight.10953577.svg\",\"36KWd\",\"blockCreateIllustrationDark.e6b33366.svg\",\"ktyyJ\",\"TrialFlags.b939323f.js\",\"8QqMt\",\"GlobalComponents.42557ec9.js\",\"2F69B\",\"vendors~small-pkgs.16ce0aa7.js\",\"8gJl0\",\"video-previous-overlay.a5089076.js\",\"lVBal\",\"video-skip-backward-fifteen.7d60ceff.js\",\"7t5Ax\",\"video-skip-forward-fifteen.8c41b0f7.js\",\"2SjHp\",\"ShareRestrictAndCopyCoordinator.5444d729.js\",\"lk4cE\",\"RequestAccessPopup.517acb2c.js\",\"4mWJk\",\"GrantAccessFlag.9c780b43.js\",\"fno6o\",\"RestrictionsDialogMountPoint.6dbe91f8.js\",\"inQqk\",\"RestrictionsDialog.389e729d.js\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"69XGw\",\"InspectPermissionsEntryPoint.7021dc29.js\",\"a8Jk0\",\"RestrictionsDialog.5edddaf9.js\",\"2VACG\",\"RestrictionsUpsellDialog.9d1dafb7.js\",\"1zoBu\",\"ChangeEditionInlineDialog.80335961.js\",\"bfhXH\",\"RestrictionsButton.f29c5e45.js\",\"geh8r\",\"AdminNavigation.97a5f455.js\",\"8s35j\",\"SpaceRolesLozenge.b1f66f48.js\",\"gRwQ3\",\"cash.f61073db.js\",\"kNFat\",\"ImpersonationFlag.4af24a30.js\",\"2Xd3I\",\"PageLayout.d66af642.js\",\"cvXSy\",\"RightPanel.214dacbb.js\",\"aoJPa\",\"main.4af251bc.js\",\"7AIwp\",\"alert-icon.236d7fa8.svg\",\"iOFzT\",\"HelpPanel.c913181f.js\",\"b3xzh\",\"LICENSES.483f3df0.js\",\"j2bbk\",\"flask.4abe7595.js\",\"1Qnbg\",\"device-mobile.e5585656.js\",\"9mBQe\",\"feed.e134a1f8.js\",\"c2Cby\",\"NotesSidebar.26acef90.js\",\"1nKqs\",\"NotesModal.273c9db9.js\",\"7149U\",\"Arrow-Image.65dd605e.svg\",\"j0sJu\",\"NoResultsImage.d0ce8889.svg\",\"jEmf3\",\"CommentsPanelFilterMenu.bdf1f2be.js\",\"fL5gS\",\"CommentsPanelFilterMenu.edbd672d.js\",\"glvWr\",\"media.1f1da11c.js\",\"aJ9z1\",\"media.runtime.8e8a1638.js\",\"2Q2ps\",\"FullPageEditorComponent.93dbef85.js\",\"ld4Wn\",\"FullPageEditorComponent.runtime.bd6d0493.js\",\"47RmW\",\"GoalPanel.3b0eaeae.js\",\"5S8LV\",\"CommentEditor.74dab9e1.js\",\"5L59z\",\"FullPageEditorComponent.9ab799be.js\",\"9H9aT\",\"bodiedSyncedBlock.657b3e16.js\",\"kFrh6\",\"NotesSidebar.07570d58.js\",\"bd1xU\",\"FullPageEditorComponent.4f13aa58.js\",\"jLEOP\",\"FullPageEditorComponent.runtime.46cc0a8d.js\",\"1vtvP\",\"CommentsPanelFilterMenu.8b4db414.js\",\"aJ9z1\",\"media.runtime.8e8a1638.js\",\"ld4Wn\",\"FullPageEditorComponent.runtime.bd6d0493.js\",\"jLEOP\",\"FullPageEditorComponent.runtime.46cc0a8d.js\",\"9ijrN\",\"modal.7b6f1fce.js\",\"8VT23\",\"FullPageEditorComponent.adbf0b48.js\",\"736as\",\"AISummaryFooter.a28dff6c.js\",\"4yXIN\",\"FullPageEditorComponent.ce1fb04d.js\",\"5UCxV\",\"RightPanel.975e38c0.js\",\"8dYdP\",\"BranchDeployLogo.cc5d4395.js\",\"beF0E\",\"formatRelative.6270d915.js\",\"bkswC\",\"FeatureFlagLogo.ccfae516.js\",\"392bg\",\"flag-filled.80b1588d.js\",\"5j5Dl\",\"NotificationsContent.fa5a18ac.js\",\"bCr24\",\"main.7a2fbaee.js\",\"lp0cK\",\"both-splash.465c87c4.svg\",\"bo7LK\",\"teams-splash.36cc0781.svg\",\"8XHrw\",\"slack-splash.73e116f6.svg\",\"lCT7Q\",\"GoalPanel.56fbc71f.js\",\"fIKbb\",\"NotificationsContent.b04ef154.js\",\"8jKp2\",\"main.c0c19225.js\",\"6xBPW\",\"toolbox-background.8cac0d99.svg\",\"cqJPj\",\"cs.b336d2ae.js\",\"k8s3i\",\"da.f6075e4a.js\",\"4wXhf\",\"de.c38df4d6.js\",\"6tXZg\",\"es.5a50c026.js\",\"ktJwC\",\"fi.294325d8.js\",\"7mgkS\",\"fr.a2cae09b.js\",\"fWDE2\",\"hu.d138f4ea.js\",\"b2OUm\",\"it.b2809393.js\",\"9PhiM\",\"ja.40a23c3c.js\",\"4d3pr\",\"ko.6f9b7a4c.js\",\"duoZ2\",\"nb.be61a2f6.js\",\"7JbfU\",\"nl.f5e1f1d1.js\",\"k9Hsp\",\"pl.f7aac886.js\",\"dNbgl\",\"pt_BR.9651a016.js\",\"53dLt\",\"ru.a93c6f38.js\",\"dCa0R\",\"sv.b2157d1a.js\",\"dR545\",\"tr.7ccea11f.js\",\"gIlXN\",\"th.6e7c21a4.js\",\"ktxue\",\"uk.e4b0c8fa.js\",\"db0Tb\",\"vi.2fbd1ac4.js\",\"cknqz\",\"zh_TW.938e09f5.js\",\"8XnIU\",\"zh.49973391.js\",\"44Ne1\",\"main.b346bba3.js\",\"bZ7A8\",\"main.0344d23f.js\",\"3xuDK\",\"show-more-vertical.91054f89.js\",\"5Qjce\",\"shortcut-pro-tip.92299e9c.js\",\"j5Z6Q\",\"main.9340f859.js\",\"eFvBU\",\"generic-error.74ae12d9.js\",\"19qJC\",\"avatar-group.f7644992.js\",\"brzrr\",\"main.23d3df22.js\",\"g5HUX\",\"experiment-legacy-content-macro.3a108a0e.js\",\"kTdzk\",\"ObjectSidebarControl.679eb767.js\",\"8Z2Eu\",\"main.101c0f92.js\",\"1y1ll\",\"main.870d36cb.js\",\"eYBaa\",\"main.44936188.js\",\"fzXjm\",\"QuickReload.72b10d6e.js\",\"aJ5As\",\"main.34f221e9.js\",\"7Rr0f\",\"dark-mode.c2768bcf.svg\",\"3U0yP\",\"light-mode.e7c3914f.svg\",\"fQA9e\",\"match-browser.a2bb9bea.svg\",\"27Dzv\",\"dark-mode.c2768bcf.svg\",\"1gUFj\",\"light-mode.e7c3914f.svg\",\"8s2Uo\",\"match-browser.a2bb9bea.svg\",\"49f46\",\"cs.077e9f4c.js\",\"jQPB7\",\"cs_CZ.02a4f979.js\",\"88bR1\",\"da.f100d419.js\",\"bwD1u\",\"da_DK.87972b77.js\",\"85kOD\",\"de.1d9843a9.js\",\"R2BG5\",\"de_DE.c262d848.js\",\"2goda\",\"en_GB.dbcbc037.js\",\"gjxqp\",\"en_ZZ.44473633.js\",\"1S2jF\",\"es.c17cb0b0.js\",\"eERmJ\",\"fi.4fa64611.js\",\"8rk64\",\"fi_FI.3920d863.js\",\"bpktO\",\"fr.903b8e7a.js\",\"aC2ty\",\"fr_FR.55477104.js\",\"lmJBr\",\"hu.531afc04.js\",\"lVBNt\",\"hu_HU.482ed985.js\",\"lnHpS\",\"it.87f71de5.js\",\"kEBAh\",\"it_IT.6068682f.js\",\"3ZAy1\",\"ja.94bc339c.js\",\"fDXOw\",\"ja_JP.b9c5af46.js\",\"45dhs\",\"ko.1eee672d.js\",\"grGen\",\"ko_KR.2eefe595.js\",\"4iqE9\",\"nb.2f604276.js\",\"bAyJY\",\"nb_NO.0e1c1672.js\",\"51EOq\",\"nl.6cc51681.js\",\"d5GjE\",\"nl_NL.36ecf941.js\",\"4ILPZ\",\"pl.1d15f5b3.js\",\"6QVYs\",\"pl_PL.4b70058e.js\",\"7HuII\",\"pt_BR.2b035f6a.js\",\"iYxvq\",\"ru.c3f08be2.js\",\"8kHli\",\"ru_RU.b5aa2be7.js\",\"dqRWB\",\"sv.937a087d.js\",\"bYWK5\",\"sv_SE.708683d2.js\",\"k0u9s\",\"th.1046cb5c.js\",\"imObn\",\"th_TH.951654d3.js\",\"chSc4\",\"tr.c7d5b86f.js\",\"dfeY8\",\"tr_TR.38e54197.js\",\"fvaoj\",\"uk.628c902d.js\",\"lT1ej\",\"uk_UA.7f80708f.js\",\"8OH5J\",\"vi.60bec7b2.js\",\"hV9Rr\",\"vi_VN.3f64294f.js\",\"k4zbq\",\"zh.74d31329.js\",\"1cNBX\",\"zh_CN.2e8ebc6e.js\",\"ii6TT\",\"zh_TW.222165d8.js\",\"4YwES\",\"PageLayout.37b14caf.js\",\"gM13h\",\"navBarButton.4f515587.js\",\"1aPQ5\",\"PageLayout.03a67821.js\",\"6XyGC\",\"atlassian-switcher.084d495c.js\",\"4NUCi\",\"cs.ee14a273.js\",\"cSX69\",\"da.f99cdb04.js\",\"deZYh\",\"de.34ce4e12.js\",\"kU59n\",\"en_GB.b074670e.js\",\"1L3Og\",\"en_ZZ.7b508cd0.js\",\"6HKYn\",\"en.5ecea674.js\",\"UHyLS\",\"es.f027bd40.js\",\"7jCUc\",\"et.1dd8203e.js\",\"jq5xm\",\"fi.6a581f83.js\",\"anfIJ\",\"fr.7efdc03a.js\",\"369Q4\",\"hu.6ad16244.js\",\"1vaU3\",\"is.5d4b1a56.js\",\"23Iwb\",\"it.811d50f8.js\",\"fFLzH\",\"ja.93485558.js\",\"hVd5u\",\"ko.476beecb.js\",\"lz5E6\",\"nb.8e72f4f6.js\",\"bdV9c\",\"nl.b5e615f4.js\",\"eDHUW\",\"pl.6c50ac52.js\",\"RmhvD\",\"pt_BR.a6835abd.js\",\"dAgm7\",\"pt_PT.fb4e7968.js\",\"f7XN4\",\"ro.17474067.js\",\"bA1DV\",\"ru.b724c50e.js\",\"5Zouf\",\"sk.a983b13a.js\",\"f6c6x\",\"sv.4bf1c120.js\",\"6VL5F\",\"th.98547a2d.js\",\"9zarI\",\"tr.30dfa199.js\",\"gtgoF\",\"uk.6e958f1b.js\",\"kkSDy\",\"vi.16131c0b.js\",\"fgDwh\",\"zh_TW.1a4dacc3.js\",\"j25uO\",\"zh.d1eb4738.js\",\"84LYM\",\"PageLayout.6274d4bc.js\",\"2PUw9\",\"robot-error.9b710643.js\",\"htm73\",\"atlassian-switcher.1f45252b.js\",\"5dGIX\",\"animation-illustration.ceb03cfe.js\",\"a3B2V\",\"jira-switcher.fb1480eb.js\",\"9B1r0\",\"confluence-switcher.bc7e03eb.js\",\"kgItH\",\"generic-switcher.1fdfc2b4.js\",\"g8jRY\",\"PageLayout.6b474114.js\",\"eEBx4\",\"render.766b1d07.js\",\"6m2wP\",\"render.eca7c500.js\",\"ctG9k\",\"render.868d449e.js\",\"2lwAY\",\"cross-flow-modal.aa1fb688.js\",\"heta6\",\"brand-dark.c4f3aa1f.svg\",\"jCm4e\",\"brand-light.292da6ea.svg\",\"7yHad\",\"generic-error-dark.e889fb23.svg\",\"kVcQH\",\"generic-error-light.9c5910ae.svg\",\"a1o0C\",\"product-active-dark.56baffde.svg\",\"8pRM9\",\"product-active-light.b1a13a2d.svg\",\"inuR8\",\"maintenance-mode-dark.12d602d4.svg\",\"gNGNH\",\"maintenance-mode-light.587ad76e.svg\",\"6t3QQ\",\"confirmation-background-dark.77a50306.svg\",\"88MVa\",\"confirmation-background-light.7ebef9cd.svg\",\"g419T\",\"jpd-roadmap-dark.275cba67.svg\",\"9gS1d\",\"jpd-roadmap-light.6bcfd0e5.svg\",\"hgaNA\",\"jpd-timeline-dark.6be64e27.svg\",\"2T2WG\",\"jpd-timeline-light.91978564.svg\",\"fzxKX\",\"confirmation-background-dark.77a50306.svg\",\"cP3Ey\",\"confirmation-background-light.7ebef9cd.svg\",\"ajkXQ\",\"jsm-general-service-management-medium-dark.72053e0e.svg\",\"acQBx\",\"jsm-general-service-management-medium-light.235e9cbc.svg\",\"ke1cn\",\"loom-generic.bd9e0a28.svg\",\"avfpP\",\"loom-generic.4fa464c9.svg\",\"i7d4e\",\"background-light.e4dc0004.png\",\"anrcs\",\"discover-features.f4a0b670.png\",\"eONDg\",\"timeline.34add4cd.js\",\"gopxm\",\"render.00e38924.js\",\"9N316\",\"render.9d0aa8ac.js\",\"603iI\",\"render.35ba330e.js\",\"dVwBo\",\"render.4a428292.js\",\"6gEtt\",\"render.3b374062.js\",\"l37ax\",\"render.aec53825.js\",\"ntv3W\",\"render.98fd4e88.js\",\"1b5ye\",\"render.60f6df70.js\",\"lXsOU\",\"render.e88a5e9c.js\",\"8Y9rK\",\"welcome-animation-light.91126d70.js\",\"l1BtG\",\"welcome-animation-dark.09187bd2.js\",\"eBicT\",\"twc.f376f02d.svg\",\"28fuf\",\"atlassian-ace-icon.dc463630.svg\",\"5CfwX\",\"render.03dc4290.js\",\"dUS4r\",\"confirmationBackgroundV2.dark.7c389c39.png\",\"6bGHk\",\"confirmationBackgroundV2.light.74baa5b8.png\",\"ksf6H\",\"confirmationVisual.dark.3beace2d.svg\",\"6H1xs\",\"confirmationVisual.light.4c2dbe9e.svg\",\"f0hWS\",\"teamworkCollectionHeaderV2.dark.88afbace.png\",\"77wr8\",\"teamworkCollectionHeaderV2.light.d5af8710.png\",\"3mvx6\",\"warning.f5011eb7.png\",\"2oFev\",\"teamwork_collection_header.dark.0d6ead39.png\",\"1BVx6\",\"teamwork_collection_header.light.46f39a8e.png\",\"lOVL5\",\"app-tiles.dark.8e97838c.png\",\"cqGeb\",\"app-tiles.light.c0171e78.png\",\"fYmaw\",\"normalizeSeatBackground.dark.3ce9cef1.png\",\"26YAb\",\"normalizeSeatBackground.light.c079ea47.png\",\"3EtHp\",\"provisioning.light.12580c01.js\",\"9m8Nr\",\"provisioning.dark.548ad10c.js\",\"4E6dy\",\"icons.light.bbb50d8d.js\",\"8JoSD\",\"icons.dark.b514e288.js\",\"bAOHw\",\"cs.929f7599.js\",\"h3G5z\",\"da.fa0962fd.js\",\"gNA0J\",\"de.1ae90d0e.js\",\"9kjAa\",\"en.b9d07f30.js\",\"vaHqY\",\"en_GB.068fdbe4.js\",\"hKKq1\",\"en_ZZ.53db0f83.js\",\"699rt\",\"es.d0e50534.js\",\"4U6vo\",\"fi.8cf50ec1.js\",\"8bauW\",\"fr.0399c367.js\",\"2XHsa\",\"hr.1f9f7560.js\",\"fQ6gV\",\"hu.f4562836.js\",\"8N1M8\",\"it.28f8885d.js\",\"64SZl\",\"ja.a1f86467.js\",\"l9rrS\",\"ko.85f4c448.js\",\"1K1DB\",\"nb.ea0f67cd.js\",\"2IhWo\",\"nl.e0db365f.js\",\"cB5tA\",\"pl.82e54223.js\",\"14y9P\",\"pt_BR.dbe8812d.js\",\"8BgQU\",\"ru.5877a6b2.js\",\"kyH38\",\"sl.abc420e7.js\",\"b8zkJ\",\"sr_RS.a5e5bb3c.js\",\"2Ypcl\",\"sr_YR.53cbdb2c.js\",\"g5vt7\",\"sv.0d055d01.js\",\"aUgRr\",\"th.cff64ee3.js\",\"dZlmW\",\"tr.f0067b82.js\",\"dP9AS\",\"uk.379da208.js\",\"7yahE\",\"vi.1724e155.js\",\"kXGHC\",\"zh.77ee9927.js\",\"aparn\",\"zh_TW.96376377.js\",\"f7nCb\",\"render.dfdc65e6.js\",\"9xrtp\",\"render.f3fd740e.js\",\"iFcso\",\"render.2c8a5b7c.js\",\"br5B5\",\"cs.77653e15.js\",\"gjHAC\",\"da.29cb31a8.js\",\"50jL1\",\"de.6ac9c578.js\",\"icT1H\",\"en-GB.6e22a219.js\",\"jHACf\",\"en-US.74c2d95c.js\",\"gxykq\",\"en-XA.93384ee1.js\",\"jwi3q\",\"en-XB.8fd7d08a.js\",\"4vq5I\",\"en-ZZ.fc86b020.js\",\"3IaOg\",\"es.bff3b1ca.js\",\"c1t91\",\"et.96209c15.js\",\"5x1Zd\",\"fi.f6d4c608.js\",\"eNry3\",\"fr.76857f57.js\",\"cmudZ\",\"hr.9eda1dd8.js\",\"qOVvt\",\"hu.ce65db05.js\",\"cLRtU\",\"it.8d47acb1.js\",\"fWDs2\",\"ja.c832628a.js\",\"isQud\",\"ko.5ab13cf1.js\",\"iX3CG\",\"nb.7e2fbe68.js\",\"5GFyb\",\"nl.1de5b36d.js\",\"fDZox\",\"pl.e8103c49.js\",\"gYq2J\",\"pt-BR.db06477b.js\",\"4MDcN\",\"ro.6b8de570.js\",\"djU0u\",\"ru.7e5f867d.js\",\"gUvh2\",\"sl.adb9638d.js\",\"kb7kZ\",\"sr-RS.3b825f92.js\",\"kGHpg\",\"sr-YR.eb30ef98.js\",\"8GEyD\",\"sr.947e8003.js\",\"gSB6X\",\"sv.aecf40aa.js\",\"9s4Da\",\"th.34906a27.js\",\"f73pl\",\"tr.c80d459d.js\",\"jmWj5\",\"uk.8f0e380b.js\",\"inGUf\",\"vi.2a03c571.js\",\"9rQBn\",\"zh-CN.da1bdc7c.js\",\"4DECc\",\"zh-TW.5274fc2e.js\",\"9GMEV\",\"PageLayout.69f51d10.js\",\"dJC82\",\"DeleteSpaceDialog.b506151a.js\",\"4ukY5\",\"AboutConfluenceDialog.fa58a665.js\",\"6wPv6\",\"GiveFeedbackDialog.1fd9d70d.js\",\"943D1\",\"ThemePopupMenu.70adb6f7.js\",\"9HjCR\",\"theme-light-thumb.1c8784c4.svg\",\"75cX5\",\"theme-dark-thumb.996efaf5.svg\",\"fc8cx\",\"theme-system-thumb.a357a448.svg\",\"umglN\",\"PageLayout.3064ec84.js\",\"4KiYL\",\"image.e5fc33c2.js\",\"5GUmv\",\"search-error-dark.43e0a164.svg\",\"14R3W\",\"search-error-light.02ef2e6f.svg\",\"5nvBH\",\"landing-dark.4ee27e71.svg\",\"kv0qb\",\"landing-light.0988f0a2.svg\",\"8yV1V\",\"no-results-dark.a00ae47b.svg\",\"3bsGr\",\"no-results-light.5ca83755.svg\",\"efZH2\",\"recent-work-client.b69afda9.js\",\"8F6ik\",\"result-provider.b352a7b8.js\",\"hHoTx\",\"error-image.3040c8c6.js\",\"lUh9w\",\"async-select.7073926f.js\",\"fEM7I\",\"static-select-filter.6fa97146.js\",\"bBtaF\",\"multi-select-filter.c24a0a7b.js\",\"3BloW\",\"image.8b35f735.js\",\"9RypW\",\"image.43b90111.js\",\"4alnS\",\"no-results-light.5ca83755.svg\",\"bE2Fu\",\"no-results-dark.a00ae47b.svg\",\"6kNSo\",\"autocorrection-renderer.caaa73ee.js\",\"eQXoP\",\"image.6d8a5de7.js\",\"yzZO6\",\"search-error-light.02ef2e6f.svg\",\"e84X7\",\"search-error-dark.43e0a164.svg\",\"6sXO4\",\"drop-down-links.e17363a5.js\",\"4Sse2\",\"image.4aa8af18.js\",\"4KkwT\",\"prequery-empty-screen-light.0988f0a2.svg\",\"eM7lm\",\"prequery-empty-screen-dark.4ee27e71.svg\",\"5kEKD\",\"upsell-modal.a382b706.js\",\"kqtzG\",\"compass-bitbucket-upsell-banner.1bbe07cf.png\",\"jjAxo\",\"smart-user-picker.f35128ab.js\",\"8XFC9\",\"ai-answer-onboarding-banner.a6bf7c51.js\",\"5QGog\",\"search-client.efba3fef.js\",\"fiCwF\",\"search-ai.4eeffc15.js\",\"eEyVs\",\"book-with-bookmark.f202cd02.js\",\"dXz7U\",\"cs.556bcfc6.js\",\"gGEZv\",\"da.916b566e.js\",\"d3blt\",\"de.1129dcf6.js\",\"59Z93\",\"en_GB.87a7041c.js\",\"kotjW\",\"en_ZZ.408d5d9a.js\",\"kK6se\",\"es.fb485858.js\",\"5xf60\",\"et.7581eb28.js\",\"9VEIz\",\"fi.248a4434.js\",\"cjdHS\",\"fr.c4409228.js\",\"Whd6n\",\"hu.e4f8e3bb.js\",\"jkUKZ\",\"is.a0ebfb14.js\",\"9LPlo\",\"it.be72c2f5.js\",\"bCZbu\",\"ja.c3a787d2.js\",\"jUfGx\",\"ko.f52eb420.js\",\"8yxgV\",\"nb.f77aad0f.js\",\"dBE2i\",\"nl.5b601b92.js\",\"6FNZU\",\"pl.ded8d527.js\",\"ilWcC\",\"pt_BR.fb69b050.js\",\"edU6Z\",\"pt_PT.94fccdb2.js\",\"atNxX\",\"ro.e8b3e3a3.js\",\"gpgvY\",\"ru.f85e5603.js\",\"3IA7L\",\"sk.9ec26891.js\",\"hpq4P\",\"sv.55ca9b59.js\",\"8WMbP\",\"th.0c08db4a.js\",\"kffHA\",\"tr.53f281ee.js\",\"2zh8u\",\"uk.87a4d0ad.js\",\"9YoTA\",\"vi.bea39ed2.js\",\"a9qyt\",\"zh.00f84f59.js\",\"04egH\",\"zh_TW.06d2f5af.js\",\"1Ojgx\",\"ai-answer-prompt.c7daf03d.js\",\"eVnxm\",\"trello-body.c7dcb1b2.js\",\"2exA8\",\"trello-popper.17b5bea6.js\",\"8Ew6s\",\"PageLayout.ffd9bb97.js\",\"gD9D1\",\"cs.9a4fe39c.js\",\"lpFHz\",\"da.8ad3468d.js\",\"fYKge\",\"de.54f4237d.js\",\"4Wlui\",\"en_GB.f82a0274.js\",\"69mwC\",\"en_ZZ.a316cbf6.js\",\"7rN2h\",\"es.774e9f47.js\",\"9Y8tZ\",\"fi.37a048a6.js\",\"jjh1v\",\"fr.a71525fc.js\",\"23sVT\",\"hr.f7564263.js\",\"eO6VH\",\"hu.491a825a.js\",\"8rFvt\",\"it.49c14d35.js\",\"lK8aI\",\"ja.205f84d2.js\",\"5j4Hn\",\"ko.9f5fe76a.js\",\"2Jfx0\",\"nb.a3fbc7e9.js\",\"c119j\",\"nl.6310525c.js\",\"lgdNv\",\"pl.445b8482.js\",\"dKIhk\",\"pt_BR.9f842658.js\",\"dwqTf\",\"ru.0f9d3597.js\",\"fbezn\",\"sl.e52931ec.js\",\"3HAPT\",\"sr_RS.4bfd1e54.js\",\"2GH4w\",\"sr_YR.ba9f6cd2.js\",\"7Qzqz\",\"sv.2193452a.js\",\"gt8Kd\",\"th.cea18fc7.js\",\"eVDdh\",\"tr.33b3b486.js\",\"hLIwJ\",\"uk.f3c9333c.js\",\"wnH66\",\"vi.35e1ae24.js\",\"5oeby\",\"zh_TW.89f36a45.js\",\"2shw0\",\"zh.b20c0baf.js\",\"ipx3Q\",\"cs.3cad4646.js\",\"jXMUM\",\"da.16f6eb3c.js\",\"idV8v\",\"de.e0f3cc5b.js\",\"kBQ9k\",\"en.0bd4da21.js\",\"birQa\",\"en_GB.88d4f04b.js\",\"01Ull\",\"en_ZZ.6dd37123.js\",\"iyrsM\",\"es.e5560556.js\",\"hPFdF\",\"fi.fcc6e11c.js\",\"k7AqX\",\"fr.e99b7329.js\",\"8sFBs\",\"hr.cec17293.js\",\"iULA4\",\"hu.47d9cce2.js\",\"gJ4Zj\",\"it.6e6e5f19.js\",\"fvcGb\",\"ja.a024eabd.js\",\"30u08\",\"ko.650be71d.js\",\"bEohT\",\"nb.8afd4904.js\",\"4TfaY\",\"nl.a917fcce.js\",\"7TRKR\",\"pl.6ed07b37.js\",\"gfmgP\",\"pt_BR.6a2b30f7.js\",\"8rjqC\",\"ru.a460108c.js\",\"c1meM\",\"sl.11346d6b.js\",\"hnoAT\",\"sr_RS.64469ac7.js\",\"h2yiB\",\"sr_YR.d8fbf165.js\",\"7t9jv\",\"sv.23a28ada.js\",\"02wkF\",\"th.dc39a324.js\",\"f9I75\",\"tr.cca86ad4.js\",\"2ArFg\",\"uk.776dd5de.js\",\"a0qFU\",\"vi.52ae92c6.js\",\"3aliZ\",\"zh.ba8eacc1.js\",\"k4Fbc\",\"zh_TW.cae3107f.js\",\"aMWDh\",\"cs.08e6bf75.js\",\"2Nhk7\",\"da.e3d100a8.js\",\"5GgLt\",\"de.5a70965d.js\",\"aeBaj\",\"en.d90d4664.js\",\"icI5m\",\"en_GB.bff582b4.js\",\"56ebG\",\"en_ZZ.d7616114.js\",\"bpm6H\",\"es.c3e763ed.js\",\"lQBW4\",\"fi.6440606a.js\",\"d3Pby\",\"fr.1a71171b.js\",\"i3KTR\",\"hr.16f65983.js\",\"jQsR5\",\"hu.35a93332.js\",\"buYUs\",\"it.3a1dfdc0.js\",\"6JyvA\",\"ja.f9be4abd.js\",\"6j4E0\",\"ko.a0607cb8.js\",\"dx2gW\",\"nb.febd3fa4.js\",\"kRxC0\",\"nl.1a44eec8.js\",\"6VYUF\",\"pl.2af9860e.js\",\"iTCSz\",\"pt_BR.0350286a.js\",\"9vlOp\",\"ru.3822d044.js\",\"9fdZA\",\"sl.8b98af39.js\",\"c1Rfq\",\"sr_RS.b027b72e.js\",\"b4t5O\",\"sr_YR.dd190751.js\",\"lPFUB\",\"sv.6f9f6b46.js\",\"cCO7Q\",\"th.da0b0ffe.js\",\"eGYFX\",\"tr.14f9b6eb.js\",\"e0Zpf\",\"uk.1f524f0e.js\",\"3mO4w\",\"vi.dacf29c1.js\",\"fJV8L\",\"zh.9e9cabbc.js\",\"aFaOB\",\"zh_TW.18ee5e0a.js\",\"c243Q\",\"cs.2a29509b.js\",\"9pwoj\",\"da.f85ed53c.js\",\"jbmlj\",\"de.000af340.js\",\"2YMwz\",\"en.25bc58a6.js\",\"apc1e\",\"en_GB.1ba9448b.js\",\"hSszq\",\"en_ZZ.45d09de4.js\",\"hMErM\",\"es.2e10b4ed.js\",\"4mauf\",\"fi.5c92bfdd.js\",\"cV78a\",\"fr.4f71955e.js\",\"a5JUA\",\"hr.6aadb1cb.js\",\"1MwbL\",\"hu.b6c6c45d.js\",\"4ep0R\",\"it.81e14be5.js\",\"6cdZj\",\"ja.7f372aa4.js\",\"aUGH0\",\"ko.fdf6c576.js\",\"bc9H8\",\"nb.a8e755f8.js\",\"jiPaz\",\"nl.3cc37fce.js\",\"7LXV4\",\"pl.9a4146f6.js\",\"dIeeW\",\"pt_BR.7128e5ea.js\",\"1NSIC\",\"ru.13459690.js\",\"iNY4f\",\"sl.263dec8c.js\",\"isQJH\",\"sr_RS.fd766dd2.js\",\"a60ql\",\"sr_YR.a4bc7a03.js\",\"4V1qv\",\"sv.638f613c.js\",\"8vbSC\",\"th.578e548f.js\",\"iwJOJ\",\"tr.81d297c9.js\",\"dlPIZ\",\"uk.56194425.js\",\"4Gbtc\",\"vi.adb49c2e.js\",\"eqiYF\",\"zh.0fe9e57a.js\",\"43BOc\",\"zh_TW.e1739f8d.js\",\"bvkZd\",\"no-results-dark.a00ae47b.svg\",\"cV42Q\",\"no-results-light.5ca83755.svg\",\"grjq7\",\"PageLayout.f00dc9dd.js\",\"gPjUw\",\"PageLayout.77edda04.js\",\"3Kg3S\",\"CreateComponent.fad2d575.js\",\"i8hiG\",\"UnreadIndicator.c9f9b434.js\",\"9y1Aa\",\"WhiteboardGAModalManager.59f47cca.js\",\"dIuWY\",\"GAOnboardingAnnouncement.98a7a653.gif\",\"jBwbI\",\"LoomMigrationModalManager.45a05c86.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"b8oHe\",\"EngagementInlineDialogWrapper.154d7754.js\",\"a6eof\",\"PageLayout.0b1b5811.js\",\"jfTrX\",\"AppNavigation.88588c5a.js\",\"hesl9\",\"RecentPages.14911ffd.js\",\"8q7U9\",\"Collaboration.a011f6bd.svg\",\"eJwDQ\",\"SearchError.ab7cb722.svg\",\"lPQcc\",\"team-preview-panel.3cb09ae0.js\",\"6JvQz\",\"PeopleItemWrapper.d29ec65b.js\",\"bf0yj\",\"modal-dialog.4ea336eb.js\",\"6SYnx\",\"teamCreateDialog.acc16435.js\",\"40B2u\",\"MenuContent.0a1fbb73.js\",\"bZtF0\",\"th.078cde1d.js\",\"9pBxJ\",\"uk.bd28f54b.js\",\"bM16t\",\"vi.1760e489.js\",\"2ZapG\",\"AppsContent.6845f9e1.js\",\"emP1M\",\"blocks.348a3d50.svg\",\"1Zku8\",\"DiscoverSection.5eec8c3e.js\",\"bVqnE\",\"CustomHomepageItem.241b4b04.js\",\"F2Q4u\",\"AppSwitcherComponentWrapper.75612a85.js\",\"5GXmr\",\"AppSwitcherContent.ddf1604a.js\",\"df12q\",\"NotificationsComponent.6270b965.js\",\"iW7i1\",\"NotesComponent.09379190.js\",\"heZTL\",\"SettingsComponent.2d48f40b.js\",\"6YgN9\",\"MenuComponent.d97ece90.js\",\"eXOVv\",\"HelpComponent.46f27af7.js\",\"01qRE\",\"SearchComponent.4e1730f6.js\",\"4L1zw\",\"work-item.e81538e5.js\",\"3SmkN\",\"page.de848e95.js\",\"cMlHc\",\"24.41b1fe59.js\",\"1wZEW\",\"cards-extension.ed28699e.js\",\"eHw9Y\",\"ProfileComponent.5d6359e1.js\",\"9IyPY\",\"ProfileMenu.3d5a589a.js\",\"9PQXU\",\"AppNavigation.b0ec8746.js\",\"jmmCO\",\"RightSidebar.215e9bb0.js\",\"aWd5V\",\"PageLayout.e8535d0d.js\",\"lgm1i\",\"StandaloneRestrictedPageOrSpace.b839d7d3.js\",\"kUiwW\",\"RestrictedPage.424a3869.js\",\"5WZOQ\",\"CantViewLight.81544b8c.svg\",\"dHMTU\",\"CantViewDark.ef25ef94.svg\",\"cOpg6\",\"CantEditLight.0ee7f232.svg\",\"37OHY\",\"CantEditDark.190a22b1.svg\",\"6f3t8\",\"AdminKeyUpSell.4d009e71.js\",\"euA5f\",\"SuperAdminEntryPoint.09e5332f.js\",\"gEi5K\",\"NotFound.55b51932.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"2OcM6\",\"RestrictedSpace.9771f7dc.js\",\"55AxV\",\"RestrictedContentIcon-Dark.bc90ae31.svg\",\"L0tFv\",\"RestrictedContentIcon-Light.e0fef1fb.svg\",\"7DDw1\",\"ConfluenceLogo.37570e84.svg\",\"k0WnS\",\"ExternalPageNotFoundV2.90c4fb16.js\",\"4J5D7\",\"not-found-v2.ab9d1086.svg\",\"lwfE5\",\"ArchiveSpacePortal.c81e1bf6.js\",\"j06N4\",\"ArchiveSpacePanel.c802491c.js\",\"d7sp9\",\"DeleteSpacePortal.bbd6edbf.js\",\"ei0Jg\",\"SpaceSettingsForgeExtensionPortal.43c161cf.js\",\"bGzhS\",\"ByLineForgeApp.68c2de65.js\",\"eMbal\",\"loading-button.90d63bac.js\",\"cjJTJ\",\"section-message.547b3afe.js\",\"jeyta\",\"no-results.603cf20f.svg\",\"edaDG\",\"CommentsPanelFilterMenu.b2ad0068.js\",\"artqy\",\"FullPageEditorComponent.6536c1b7.js\",\"180c6\",\"FullPageEditorComponent.runtime.9ab7ada4.js\",\"lqFMg\",\"ByLineForgeApp.64688b4a.js\",\"8Kivm\",\"ByLineForgeApp.018b6222.js\",\"jigcs\",\"LabelsSelect.2cc2d62f.js\",\"718G0\",\"LabelsSelectErrors.6ba11745.js\",\"4LmEY\",\"ViewPageLabels.116e6128.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.9ae729b7.js\",\"180c6\",\"FullPageEditorComponent.runtime.9ab7ada4.js\",\"bdzih\",\"ContentActionForgeApp.ccdb1884.js\",\"cwpVK\",\"ContextMenuForgeApp.9fa182ae.js\",\"68RC4\",\"FullPageForgeApp.f7435a0b.js\",\"87cDu\",\"GlobalPageForgeApp.35f38a3c.js\",\"iXr0W\",\"GlobalSettingsForgeApp.c321a992.js\",\"ccJug\",\"HomepageFeedForgeApp.848deb52.js\",\"irYLY\",\"SpaceSettingsForgeApp.b6ae48fc.js\",\"ldtPf\",\"SpacePageForgeApp.844e6666.js\",\"6wcNV\",\"CustomContentForgeApp.bd05764e.js\",\"i9jMB\",\"BackgroundScriptForgeApp.f08c1f81.js\",\"aFNXd\",\"PageBannerForgeApp.035f8386.js\",\"hhf8b\",\"SpaceTrashPortal.3897b499.js\",\"an2zh\",\"SiteSettingsHelpPanelLink.48fe27c8.js\",\"gJRFC\",\"BackupManagerButton.576a1571.js\",\"22rRN\",\"dashboard-spa-container-jquery3.fab75acb.js\",\"iQ5nE\",\"dashboard-spa-container-jquery3.runtime.c6c431b2.js\",\"aZinD\",\"vendors.96e00e06.js\",\"eiF7i\",\"stable_vendors.251bfc4c.js\"]"));
 }, ["7EorR","22rRN","iQ5nE","aZinD","eiF7i","hhss7","ffEVr","1yVM6","1qlDN","5pvpJ","6XCf4","4TxwY","6wr18"]);
$parcel$global.rwr("3pblT", () => { 
var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $5QpZa = parcelRequire("5QpZa");


var $hp2SH = parcelRequire("hp2SH");


var $iC5L0 = parcelRequire("iC5L0");


var $aXEzU = parcelRequire("aXEzU");





var $3WLLD = parcelRequire("3WLLD");


var $bj5fB = parcelRequire("bj5fB");





var $7J5Uc = parcelRequire("7J5Uc");

const $14d55bbfca2abbc5$export$7a88623f52f1b79 = (initialTheme)=>{
    const [{ isInitialized: isInitialized }, { initializeTheme: initializeTheme }] = (0, $7J5Uc.useThemingState)();
    (0, $42omo.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isInitialized;
};


const $e6baa9171970034d$export$11eb671888ed6e7d = ({ children: children })=>{
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    const isInitialized = (0, $14d55bbfca2abbc5$export$7a88623f52f1b79)(initialTheme);
    if (!isInitialized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};



var $7zgzO = parcelRequire("7zgzO");


var $awd1Q = parcelRequire("awd1Q");


var $9j59h = parcelRequire("9j59h");


var $xwvlW = parcelRequire("xwvlW");


var $8PKGr = parcelRequire("8PKGr");


var $68uaC = parcelRequire("68uaC");


var $17wUi = parcelRequire("17wUi");


var $gnYQc = parcelRequire("gnYQc");


var $2DVQX = parcelRequire("2DVQX");


var $7LuKf = parcelRequire("7LuKf");





var $6g1oe = parcelRequire("6g1oe");


var $4xcIM = parcelRequire("4xcIM");


var $2FNjD = parcelRequire("2FNjD");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $cryCi = parcelRequire("cryCi");


var $dBmJE = parcelRequire("dBmJE");








var $kFqI2 = parcelRequire("kFqI2");


var $T1bCI = parcelRequire("T1bCI");


var $lonEO = parcelRequire("lonEO");


var $iJELi = parcelRequire("iJELi");


var $d5ap9 = parcelRequire("d5ap9");


var $hmRc4 = parcelRequire("hmRc4");


var $fcF01 = parcelRequire("fcF01");


var $iJiK8 = parcelRequire("iJiK8");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $25MM7 = parcelRequire("25MM7");





var $jVK0t = parcelRequire("jVK0t");


var $64KID = parcelRequire("64KID");


var $kZDrw = parcelRequire("kZDrw");


var $8n9tL = parcelRequire("8n9tL");


var $1ytiN = parcelRequire("1ytiN");


var $a5txT = parcelRequire("a5txT");


var $97W74 = parcelRequire("97W74");

class $7db816b9e13721ff$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    getChildContext() {
        const { context: context } = this.props;
        const noop = ()=>{};
        return {
            insertCss: context.insertCss || noop
        };
    }
    render() {
        const { store: store } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Provider), {
            inject: [
                (0, $a5txT.getStandalonePageTreeStateUpdater)()
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lonEO.GraphqlProvider), {
            client: (0, $hp2SH.getApolloClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kFqI2.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dBmJE.ConnectedRouter), {
            history: this.browserHistory,
            context: (0, $kFqI2.ReactReduxContext)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8n9tL.RouteManager), {
            namedRoutes: (0, $64KID.namedRoutes)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJiK8.Dialogs), null), this.props.children))))))))))));
    }
    constructor(...args){
        super(...args);
        this.browserHistory = (0, $hmRc4.getBrowserHistory)();
    }
}
$7db816b9e13721ff$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    /**
   * Context including the css handler (It has different versions for client and server rendering)
   */ context: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    }),
    /**
   * Children Component
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    /**
   * Indicates if the component is rendered as Root
   */ renderAsRoot: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$7db816b9e13721ff$export$2e2bcd8739ae039.childContextTypes = {
    /**
   * Handler for css injection in components.
   */ insertCss: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};



var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");

const $d4f95b5cede9219f$var$store = (0, $3Tw8v.default)({
    isServerRenderedPage: true
});
(0, $9F7Qb.subscribe)($d4f95b5cede9219f$var$store);
const $d4f95b5cede9219f$var$context = {
    insertCss: (styles)=>styles._insertCss()
};
/**
 * Method for rendering React/Redux component
 * Usage:
 * import renderComponent from './renderComponentIntoDOM';
 * renderComponent(<YourComponent />, 'your-component-section-id');
 * OR renderComponent(<YourComponent />, DOMComponent);
 *
 * @param children
 * @param container DOM node or id string
 */ const $d4f95b5cede9219f$var$renderComponentIntoDOM = (children, container, renderAsRoot = false)=>{
    if (typeof container === 'string') container = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.getElementById(container);
    const Component = ({ sessionData: sessionData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7db816b9e13721ff$export$2e2bcd8739ae039), {
            store: $d4f95b5cede9219f$var$store,
            context: $d4f95b5cede9219f$var$context,
            renderAsRoot: renderAsRoot
        }, children)));
    Component.propTypes = {
        sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired
    };
    (0, $ge2sX.getSessionData)().then((sessionData)=>{
        const concurrentComponentWrapper = (0, $2FNjD.createRoot)(container);
        concurrentComponentWrapper.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            sessionData: sessionData
        }));
    });
};
var $d4f95b5cede9219f$export$2e2bcd8739ae039 = $d4f95b5cede9219f$var$renderComponentIntoDOM;



var $7RVQB = parcelRequire("7RVQB");




/**
 * These helper functions should be used to minimize the impact the standalone sidebar causes to the ui (jump, flip, flash, jank);
 */ const $8bee1fe38b9eef04$var$mainSectionsSelectors = [
    '#main',
    '#admin-content',
    '#custom-content-container',
    '.ap-servlet-placeholder'
];
const $8bee1fe38b9eef04$export$ed04e7f6ba662aee = ()=>{
    const head = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.head || (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector('head');
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createElement('style');
    const css = `${$8bee1fe38b9eef04$var$mainSectionsSelectors.join(',')} { opacity: 0 };`;
    style.type = 'text/css';
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild((0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.createTextNode(css));
    if (head) head.appendChild(style);
};
const $8bee1fe38b9eef04$export$4011f4c5a8044281 = (runs = 0)=>{
    const mainContainers = $8bee1fe38b9eef04$var$mainSectionsSelectors.map((selector)=>(0, (/*@__PURE__*/$parcel$interopDefault($6g1oe))).document.querySelector(selector)).filter((ele)=>ele !== null);
    if (mainContainers.length) mainContainers.forEach((container)=>{
        if (container) {
            container.style.transition = 'opacity .15s ease-in';
            container.style.opacity = '1';
        }
    });
    else // accounting for any race condition that could delay the parsing of the content
    if (runs < 5) {
        console.warn('Legacy pages: trying to fix jank behaviour on legacy pages but content container is not found yet');
        setTimeout(()=>$8bee1fe38b9eef04$export$4011f4c5a8044281(runs + 1), 100);
    } else console.error('Legacy pages: content container was not found');
};






var $iyEDi = parcelRequire("iyEDi");


var $gnnzK = parcelRequire("gnnzK");


var $1NBp8 = parcelRequire("1NBp8");

/* StandaloneConfluenceNavigation.js generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $3pfAb = parcelRequire("3pfAb");


var $NAPtM = parcelRequire("NAPtM");


var $3u0dr = parcelRequire("3u0dr");





var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $bQm3c = parcelRequire("bQm3c");











var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");


var $30qWc = parcelRequire("30qWc");





var $gqqjz = parcelRequire("gqqjz");








var $b1HmN = parcelRequire("b1HmN");


var $eSUdr = parcelRequire("eSUdr");

const $13bb14eac5ea00fc$export$bae28e68d0aa638c = (0, $eSUdr.default)`mutation ClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}`;


const $e5314625536bb69f$export$8a37b2ec23f0faea = 'confluence-change-edition-remove-restrictions-button';
const $e5314625536bb69f$export$9f92e67dea336ca7 = 'confluence-change-edition-notification-dialog';
const $e5314625536bb69f$var$i18n = (0, $cgtv4.defineMessages)({
    removeRestrictionButton: {
        id: "change-edition.notification.dialog.general.button.remove-restrictions",
        defaultMessage: "Remove restrictions"
    },
    removeRestrictionTitle: {
        id: "change-edition.notification.dialog.general.title.remove-restrictions-2",
        defaultMessage: "Remove restrictions?"
    },
    removeRestrictionTextSpaceLevel: {
        id: "change-edition.notification.dialog.space.text.remove-restrictions",
        defaultMessage: "You\u2019re on the free plan, so you can only <b>remove all restrictions</b> from <b>{contentTitle}</b>. <b>This can\u2019t be undone.</b> You won\u2019t be able to reset the restrictions later."
    },
    removeRestrictionConfirmationSuccessTitle: {
        id: "change-edition.notification.dialog.confirmation.success.title",
        defaultMessage: "Restrictions removed"
    },
    removeRestrictionConfirmationSuccessDesc: {
        id: "change-edition.notification.dialog.confirmation.success.desc",
        defaultMessage: "Anyone who\u2019s logged in can now view and edit {contentTitle}."
    },
    removeRestrictionConfirmationFailedTitle: {
        id: "change-edition.notification.dialog.confirmation.failed.title",
        defaultMessage: "Page restrictions not removed"
    },
    removeRestrictionConfirmationFailedDesc: {
        id: "change-edition.notification.dialog.confirmation.failed.desc",
        defaultMessage: "We couldn\u2019t remove restrictions from {contentTitle}. Try again."
    }
});
const $e5314625536bb69f$var$DEFAULT_COMPONENT_STATE = {
    isNotificationOpen: false,
    isMutationInProcess: false,
    contentId: null,
    contentTitle: null
};
//TODO: remove dep on shared i18n.
const $e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n = (0, $cgtv4.defineMessages)({
    // Notification Dialog --------------------
    cancelButton: {
        id: "change-edition.general.button.cancel",
        defaultMessage: "Cancel"
    }
});
class $e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.addEventListener('click', this.openNotificationDialog);
        });
    }
    componentWillUnmount() {
        Array.prototype.forEach.call(this.allRemoveRestrictionsElements, (el)=>{
            el.removeEventListener('click', this.openNotificationDialog);
        });
    }
    render() {
        const { intl: intl } = this.props;
        const { isNotificationOpen: isNotificationOpen, isMutationInProcess: isMutationInProcess, contentTitle: contentTitle, contentId: contentId } = this.state;
        if (!this.placeholderEl) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const route = matchRoute(location.pathname);
            // Skip rendering for other then "Space Setting / Restricted Page" page
            if (!route || route.name != (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
                    mutation: (0, $13bb14eac5ea00fc$export$bae28e68d0aa638c),
                    variables: {
                        contentId: contentId
                    },
                    onCompleted: this.handleMutationComplete(flags),
                    onError: this.handleMutationError(flags)
                }, (clearRestrictionsForFreeMutation)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1HmN.LoadableChangeEditionNotificationDialog), {
                        isOpen: isNotificationOpen,
                        isProcessing: isMutationInProcess,
                        cancelAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$changeEditionPageRestrictionsLegacyCoordinatorI18n.cancelButton),
                            onClick: this.closeNotificationDialog
                        },
                        applyAction: {
                            text: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionButton),
                            onClick: this.applyChanges(clearRestrictionsForFreeMutation)
                        },
                        heading: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionTitle),
                        source: "individualSpaceRestrictedPages",
                        grandfathered: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                        ...$e5314625536bb69f$var$i18n.removeRestrictionTextSpaceLevel,
                        values: {
                            contentTitle: contentTitle,
                            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
                        }
                    })))), this.placeholderEl);
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ...$e5314625536bb69f$var$DEFAULT_COMPONENT_STATE
        };
        this.allRemoveRestrictionsElements = window.document.getElementsByClassName($e5314625536bb69f$export$8a37b2ec23f0faea) || [];
        this.placeholderEl = window.document.getElementById($e5314625536bb69f$export$9f92e67dea336ca7);
        this.openNotificationDialog = (event)=>{
            this.setState({
                isNotificationOpen: true,
                contentId: event.target.getAttribute('data-page-id'),
                contentTitle: event.target.getAttribute('data-page-title')
            });
        };
        this.closeNotificationDialog = ()=>{
            this.setState($e5314625536bb69f$var$DEFAULT_COMPONENT_STATE);
        };
        this.applyChanges = (mutationFunction)=>()=>{
                this.setState({
                    isMutationInProcess: true
                });
                mutationFunction();
            };
        this.handleMutationComplete = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showSuccessFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationSuccessDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
                window.setTimeout(()=>{
                    // refresh the page to see the changes
                    window.location.reload();
                }, 500);
            };
        this.handleMutationError = (flags)=>()=>{
                const { intl: intl } = this.props;
                const { contentTitle: contentTitle } = this.state;
                flags.showErrorFlag({
                    title: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedTitle),
                    description: intl.formatMessage($e5314625536bb69f$var$i18n.removeRestrictionConfirmationFailedDesc, {
                        contentTitle: contentTitle
                    })
                });
                this.closeNotificationDialog();
            };
    }
}
$e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $e5314625536bb69f$export$5b44234181f42094 = (0, $gmMgo.default)($e5314625536bb69f$var$ChangeEditionPageRestrictionsLegacyCoordinatorComponent);


















var $frIzR = parcelRequire("frIzR");







var $8C5kA = parcelRequire("8C5kA");





var $4WmbV = parcelRequire("4WmbV");

const $4c2daaa3bc0c282d$var$i18n = (0, $cgtv4.defineMessages)({
    siteAdminAuditLogsTitle: {
        id: "change-edition.section.message.site-admin.audit-logs.title",
        defaultMessage: "Upgrade for Audit logs"
    },
    nonSiteAdminAuditLogsTitle: {
        id: "change-edition.section.message.non-site-admin.audit-logs.title",
        defaultMessage: "Audit logs are only available on paid plans"
    },
    siteAdminAuditLogsBody: {
        id: "change-edition.section.message.site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs. To access the audit logs, upgrade your plan."
    },
    nonSiteAdminAuditLogsBody: {
        id: "change-edition.section.message.non-site-admin-audit-logs.body",
        defaultMessage: "You\u2019re on the free plan, so you can\u2019t view and track changes made across your site in the audit logs."
    }
});
const $4c2daaa3bc0c282d$export$cb2ba78fe55aff74 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(9);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    let t0;
    if ($[0] !== formatMessage || $[1] !== title) {
        t0 = formatMessage(title);
        $[0] = formatMessage;
        $[1] = title;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== body || $[4] !== formatMessage) {
        t1 = formatMessage(body);
        $[3] = body;
        $[4] = formatMessage;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t0 || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            title: t0,
            body: t1,
            source: "auditLogs"
        });
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const title = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsTitle : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsTitle;
    const body = isSiteAdmin ? $4c2daaa3bc0c282d$var$i18n.siteAdminAuditLogsBody : $4c2daaa3bc0c282d$var$i18n.nonSiteAdminAuditLogsBody;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: formatMessage(title),
        body: formatMessage(body),
        source: "auditLogs"
    });
};




















var $f7Bnv = parcelRequire("f7Bnv");




const $ee74963fbde2c4ed$var$i18n = (0, $cgtv4.defineMessages)({
    siteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.site-admin.content-restrictions.title",
        defaultMessage: "Upgrade for content-level restrictions"
    },
    nonSiteAdminContentRestrictionsTitle: {
        id: "change-edition.section.message.non-site-admin.content-restrictions.title",
        defaultMessage: "Content-level restrictions are only available on paid plans"
    },
    spaceRestrictedPagesText: {
        id: "change-edition.section.message.space-restricted-pages.text",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below. To set restrictions, upgrade your plan."
    },
    nonSiteAdminGrandfatheredRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.grandfathered.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so you can only remove all restrictions from content by clicking the lock icon below."
    },
    siteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.site-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything. To set restrictions, upgrade your plan."
    },
    nonSiteAdminRestrictedPagesBody: {
        id: "change-edition.section.message.non-admin.space-restricted-pages.body",
        defaultMessage: "You\u2019re on the free plan, so anyone who\u2019s logged in can view and edit everything."
    }
});
function $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered) {
    if (grandfathered) {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.spaceRestrictedPagesText;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminGrandfatheredRestrictedPagesBody;
    } else {
        if (isSiteAdmin) return $ee74963fbde2c4ed$var$i18n.siteAdminRestrictedPagesBody;
        else return $ee74963fbde2c4ed$var$i18n.nonSiteAdminRestrictedPagesBody;
    }
}
const $ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { grandfathered: grandfathered, isSiteAdmin: isSiteAdmin } = t0;
    const intl = (0, $8C5kA.default)();
    let T0;
    let t1;
    let t2;
    if ($[0] !== grandfathered || $[1] !== intl || $[2] !== isSiteAdmin) {
        const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
        const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
        T0 = (0, $4WmbV.ChangeEditionSectionMessage);
        if ($[6] !== intl || $[7] !== title) {
            t1 = intl.formatMessage(title);
            $[6] = intl;
            $[7] = title;
            $[8] = t1;
        } else t1 = $[8];
        t2 = intl.formatMessage(bodyText);
        $[0] = grandfathered;
        $[1] = intl;
        $[2] = isSiteAdmin;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
    }
    let t3;
    if ($[9] !== T0 || $[10] !== t1 || $[11] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            title: t1,
            body: t2,
            source: "individualSpaceRestrictedPages"
        });
        $[9] = T0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ grandfathered: grandfathered, isSiteAdmin: isSiteAdmin })=>{
    const intl = (0, $8C5kA.default)();
    const bodyText = $ee74963fbde2c4ed$var$getBody(isSiteAdmin, grandfathered);
    const title = isSiteAdmin ? $ee74963fbde2c4ed$var$i18n.siteAdminContentRestrictionsTitle : $ee74963fbde2c4ed$var$i18n.nonSiteAdminContentRestrictionsTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        title: intl.formatMessage(title),
        body: intl.formatMessage(bodyText),
        source: "individualSpaceRestrictedPages"
    });
};
$ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent.propTypes = {
    grandfathered: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired,
    isSiteAdmin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};
const $ee74963fbde2c4ed$export$51350d82d36f7e43 = (0, $f7Bnv.withIsSiteAdmin)($ee74963fbde2c4ed$var$ChangeEditionSectionMessageSpaceContentComponent);


const $63cbc74b40cb8d33$export$4a53029580aac53e = 'confluence-change-edition-section-message';
class $63cbc74b40cb8d33$export$b9f1eac8c818cdb0 extends (0, $42omo.Component) {
    isSectionMessageNeeded(routeName) {
        return routeName && Boolean(this.ROUTE_NAME2COMPONENT[routeName.name]);
    }
    getComponentParams(routeName) {
        if (routeName === (0, $1NBp8.SPACE_RESTRICTED_PAGES).name) return {
            grandfathered: this.el.getAttribute('data-grandfathered') === 'true'
        };
        return {};
    }
    render() {
        if (!this.el) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>{
            const routeName = matchRoute(location.pathname + location.search);
            if (!this.isSectionMessageNeeded(routeName)) return null;
            const ChangEditionComponent = this.ROUTE_NAME2COMPONENT[routeName.name];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ChangEditionComponent, this.getComponentParams(routeName.name)), this.el);
        });
    }
    constructor(...args){
        super(...args);
        this.el = window.document.getElementById($63cbc74b40cb8d33$export$4a53029580aac53e);
        this.ROUTE_NAME2COMPONENT = {
            [(0, $1NBp8.SPACE_RESTRICTED_PAGES).name]: (0, $ee74963fbde2c4ed$export$51350d82d36f7e43),
            [(0, $1NBp8.ADMIN_AUDIT_LOG).name]: (0, $4c2daaa3bc0c282d$export$cb2ba78fe55aff74)
        };
    }
}


const $f60f9bb0af41c642$export$ddc928ad192d2b94 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $bQm3c.useSessionData)().edition === "FREE" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;
} : ()=>(0, $bQm3c.useSessionData)().edition === 'FREE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63cbc74b40cb8d33$export$b9f1eac8c818cdb0), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5314625536bb69f$export$5b44234181f42094), null))) : null;






var $4PPzL = parcelRequire("4PPzL");


var $04e9M = parcelRequire("04e9M");


var $56QzY = parcelRequire("56QzY");


var $1dnxO = parcelRequire("1dnxO");


var $aeSHO = parcelRequire("aeSHO");


var $iJ8K8 = parcelRequire("iJ8K8");


var $4l6Wo = parcelRequire("4l6Wo");


var $hDG7z = parcelRequire("hDG7z");


var $eWwvy = parcelRequire("eWwvy");


var $39rFu = parcelRequire("39rFu");





var $cBuRD = parcelRequire("cBuRD");





var $eIKcA = parcelRequire("eIKcA");





var $ezLwY = parcelRequire("ezLwY");

/**
 * shortcutContext('global') or shortcutContext(['global', 'viewcontent'])
 * @param context
 * @returns {Function}
 */ function $089e60b6c1a73ffc$var$shortcutContext(context) {
    return (BaseComponent)=>{
        class ShortcutContextComponent extends (0, $42omo.Component) {
            componentDidMount() {
                (0, $ezLwY.enableContext)(context);
            }
            componentWillUnmount() {
                (0, $ezLwY.disableContext)(context);
            }
            render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BaseComponent, this.props);
            }
        }
        ShortcutContextComponent.displayName = `ShortcutContextComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return ShortcutContextComponent;
    };
}
var $089e60b6c1a73ffc$export$2e2bcd8739ae039 = $089e60b6c1a73ffc$var$shortcutContext;



var $jmjWc = parcelRequire("jmjWc");


const $f05a18473f890654$export$ffff49ea750347f8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3CTAv",
    name: "StandaloneRestrictedPageOrSpace",
    loader: async ()=>(await (parcelRequire("fmuCC"))).StandaloneRestrictedPageOrSpace
});



var $jwv1p = parcelRequire("jwv1p");


var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $4QflW = parcelRequire("4QflW");





var $ba9cbe60fdf9141e$exports = {};

var $bCMS0 = parcelRequire("bCMS0");


var $daAKm = parcelRequire("daAKm");


var $ehlgT = parcelRequire("ehlgT");


var $fPVB6 = parcelRequire("fPVB6");

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function $ba9cbe60fdf9141e$var$endsWith(string, target, position) {
    string = $fPVB6(string);
    target = $daAKm(target);
    var length = string.length;
    position = position === undefined ? length : $bCMS0($ehlgT(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
$ba9cbe60fdf9141e$exports = $ba9cbe60fdf9141e$var$endsWith;



var $jzEl8 = parcelRequire("jzEl8");

const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED = [
    '#action-page-permissions-link'
];
const $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION = [
    '#page-favourite',
    '#action-menu-link'
];
const $9117dce6b863f439$var$replacedPlaceholder = {
    elementName: 'span',
    attributes: {
        style: `display: none`
    }
};
function $9117dce6b863f439$export$9e2c81a475b5d1b8() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED,
        attempts: 100,
        retryDelay: 500,
        portalNode: null,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ba9cbe60fdf9141e$exports)))(window.location.pathname, '/pages/viewinfo.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jzEl8.LegacyDOMBridge), {
        selectors: $9117dce6b863f439$var$LINKS_TO_BE_REMOVED_ON_PAGE_INFORMATION,
        attempts: 100,
        retryDelay: 500,
        replacePlaceholderWith: $9117dce6b863f439$var$replacedPlaceholder,
        portalNode: null
    }));
}














var $inPa6 = parcelRequire("inPa6");








const $b82761c2a95901d5$export$18a8a22069631f81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kdP2C",
    loader: async ()=>(await (parcelRequire("5qwh1"))).ArchiveSpacePortal,
    name: 'ArchiveSpacePortal'
});






const $e87d969ba20a20a0$export$854f67824ef9311 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "P3ji1",
    loader: async ()=>(await (parcelRequire("2NJWg"))).DeleteSpacePortal,
    name: 'DeleteSpacePortal'
});






const $a6c6b76f924ecb80$export$b4b583c595949768 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BlJ6r",
    name: "LazySpaceSettingsForgeExtensionPortal",
    loader: async ()=>(await (parcelRequire("cq0jI"))).SpaceSettingsForgeExtensionPortal
});
$a6c6b76f924ecb80$export$b4b583c595949768.displayName = 'LazySpaceSettingsForgeExtensionPortal';



var $7QM6o = parcelRequire("7QM6o");


var $feuG2 = parcelRequire("feuG2");





const $b270d87888ab1caf$export$cca256d7c562dc07 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTzRP",
    loader: async ()=>(await (parcelRequire("7nmkU"))).SpaceTrashPortal,
    name: 'SpaceTrashPortal'
});






const $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wu877",
    name: "SiteSettingsHelpPanelLink",
    loader: async ()=>(await (parcelRequire("ax8Zf"))).SiteSettingsHelpPanelLink
});






const $406f60e313bf3a3f$export$b52880da76836cd4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "h3QZB",
    name: "BackupManagerButton",
    loader: async ()=>(await (parcelRequire("d1Pi6"))).BackupManagerButton
});



var $14QAi = parcelRequire("14QAi");


var $ep3mz = parcelRequire("ep3mz");

/* PdfBannerPortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");





var $6mKj3 = parcelRequire("6mKj3");

const $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID = 'pdf-export-banner-root';
const $530cf45a0f14746c$var$i18n = (0, $cgtv4.defineMessages)({
    bannerMessage: {
        id: "pdf-export.banner.message",
        defaultMessage: "We've received your print request. To maintain your page's format, we're exporting it to a PDF for you to download and print."
    }
});
const $530cf45a0f14746c$var$styles = {
    bannerStyles: "_1yt4pxbi _bfhk1aqn _1bto1l2s _o5721q9c"
};
const $530cf45a0f14746c$var$PdfBanner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $530cf45a0f14746c$var$styles.bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $530cf45a0f14746c$var$i18n.bannerMessage)));
const $530cf45a0f14746c$export$57cc11a378563774 = ()=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    if (!(0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true)) return null;
     // only inject if ?showPdfBanner=true
    if (queryParams.showPdfBanner !== 'true') return null;
    let targetElement = document.getElementById($530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID); // if the target doesn't exist, create and insert it before <main>
    if (!targetElement) {
        const main = document.querySelector('main#main');
        if (main && main.parentElement) {
            targetElement = document.createElement('div');
            targetElement.id = $530cf45a0f14746c$var$PDF_BANNER_PORTAL_ID;
            main.parentElement.insertBefore(targetElement, main);
        }
    } // if no anchor could be found, bail
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($530cf45a0f14746c$var$PdfBanner, null), targetElement);
};


const $76c1a3880217c32d$var$i18n = (0, $cgtv4.defineMessages)({
    importingTemplates: {
        id: "standalone-navigation.importing.templates",
        defaultMessage: "More about importing templates"
    }
});
const $76c1a3880217c32d$export$fc287ab47b11c4ec = ({ spaceKey: spaceKey, isSpaceSettingsScreen: isSpaceSettingsScreen })=>{
    const { location: { pathname: pathname } } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $42omo.useEffect)(()=>{
        const { section: section, screen: screen } = (0, $14QAi.getRouteData)(pathname);
        // We only want analytics for IPH specific routes for now
        if (screen !== 'notTracked') createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: screen,
                attributes: {
                    section: section
                }
            }
        }).fire();
    }, [
        pathname,
        createAnalyticsEvent,
        spaceId
    ]);
    return pathname && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isSpaceSettingsScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ep3mz.PageStateContainer), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $feuG2.SpaceSettingsNavigationV2Portal), {
        spaceKey: spaceKey
    })) : null, pathname.includes('/spaces/archivespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b82761c2a95901d5$export$18a8a22069631f81), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/spaces/removespace.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e87d969ba20a20a0$export$854f67824ef9311), {
        spaceKey: spaceKey,
        pathname: pathname
    }), pathname.includes('/pages/viewtrash.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b270d87888ab1caf$export$cca256d7c562dc07), {
        spaceKey: spaceKey
    }), pathname.includes('/templatePackage/configurePlugin.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2b3f21ec8a84bb2$export$2c12a08ca2f15d0e), {
        articleId: "7p0QTJJI0VkoU49M4GzKH2",
        articleTopic: "admin-import-templates",
        portalTargetId: "site-settings-import",
        buttonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $76c1a3880217c32d$var$i18n.importingTemplates),
        pathname: pathname,
        routeGroup: "site-settings",
        routeName: "undefined"
    }), pathname.includes('/plugins/servlet/ondemandbackupmanager') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $406f60e313bf3a3f$export$b52880da76836cd4), {
        pathname: pathname
    }), pathname.includes('spaces/flyingpdf/pdfpageexport.action') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $530cf45a0f14746c$export$57cc11a378563774), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6c6b76f924ecb80$export$b4b583c595949768), {
        spaceKey: spaceKey
    }));
};
// needed for react-proptypes warning
$76c1a3880217c32d$export$fc287ab47b11c4ec.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};


var $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation;
function $7c0ba11073bcb5f1$var$_defineProperty(e, r, t) {
    return (r = $7c0ba11073bcb5f1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7c0ba11073bcb5f1$var$_toPropertyKey(t) {
    var i = $7c0ba11073bcb5f1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c0ba11073bcb5f1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $7c0ba11073bcb5f1$var$TopNavSpacer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1ule _1bsb1osq _4t3iymf6",
            __cmplp.className
        ])
    });
});
var $7c0ba11073bcb5f1$export$2e2bcd8739ae039 = (0, $089e60b6c1a73ffc$export$2e2bcd8739ae039)('global')(($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation = class StandaloneConfluenceNavigation extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { isAdminScreen: isAdminScreen } = this.props; // if admin screen, show content as we mount
        if (isAdminScreen) (0, $8bee1fe38b9eef04$export$4011f4c5a8044281)();
        else setTimeout((0, $8bee1fe38b9eef04$export$4011f4c5a8044281), 300);
        (0, $ge2sX.getSessionData)();
    }
    render() {
        const { isAdminScreen: isAdminScreen, isSpaceSettingsScreen: isSpaceSettingsScreen, isSpaceScreen: isSpaceScreen, route: route, spaceKey: spaceKey } = this.props;
        let navView;
        if ((0, $1dnxO.getIsNav4Enabled)() && isSpaceSettingsScreen) navView = (0, $4l6Wo.CONTAINER_ADMIN_HOME_ID);
        else if (isSpaceSettingsScreen || isSpaceScreen) navView = (0, $4l6Wo.CONTAINER_HOME_ID);
        else if (isAdminScreen) navView = (0, $4l6Wo.ADMIN_HOME_ID);
        else if (route?.name !== (0, $1NBp8.EXTERNAL_SHARE).name) // XXX EXTERNAL_SHARE does not have the typical navigation.
        navView = (0, $4l6Wo.PRODUCT_HOME_ID);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f05a18473f890654$export$ffff49ea750347f8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $76c1a3880217c32d$export$fc287ab47b11c4ec), {
            spaceKey: spaceKey,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pfAb.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
            nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
            livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ8K8.Screen), {
            screenEvent: {
                name: 'serverRenderedScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW)
            }
        }, navView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hDG7z.PageLayout), {
            view: navView,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            standalone: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eIKcA.default), null), isSpaceSettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9117dce6b863f439$export$9e2c81a475b5d1b8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBuRD.NotificationLandedEvent), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f60f9bb0af41c642$export$ddc928ad192d2b94), null));
    }
    constructor(...args){
        super(...args);
        $7c0ba11073bcb5f1$var$_defineProperty(this, "spacer", ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7c0ba11073bcb5f1$var$TopNavSpacer, {
                "data-test-id": "top-nav-spacer"
            }));
    }
}, $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "displayName", 'StandaloneConfluenceNavigation'), $7c0ba11073bcb5f1$var$_defineProperty($7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation, "propTypes", {
    isAdminScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isSpaceSettingsScreen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    route: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
}), $7c0ba11073bcb5f1$var$_StandaloneConfluenceNavigation));


const $fe485fa379bdff14$var$getSpaceKey = (state)=>{
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    return (0, $iyEDi.routerStateExists)(state) && routeParams && routeParams.spaceKey || state.meta.get('space-alias') || state.meta.get('space-key');
};
const $fe485fa379bdff14$var$mapStateToProps = (state, props)=>{
    const { location: location, matchRoute: matchRoute } = props;
    const isSpaceScreen = state.meta.get('is-space-page') === 'true' || (0, $gnnzK.isContentTypeOf)('page', state) || (0, $gnnzK.isContentTypeOf)('blogpost', state);
    //On the DELETE_SPACE_LEGACY path the space is already deleted but certain queries
    //use the spaceKey. Set spaceKey to null if on this path
    const route = matchRoute(`${location.pathname}${location.search}${location.hash}`);
    const spaceKey = route?.name === (0, $1NBp8.DELETE_SPACE_LEGACY).name ? null : $fe485fa379bdff14$var$getSpaceKey(state);
    return {
        isAdminScreen: state.meta.get('is-admin-page') === 'true',
        isSpaceScreen: isSpaceScreen,
        isSpaceSettingsScreen: state.meta.get('is-space-tool-page') === 'true',
        route: route,
        spaceKey: spaceKey
    };
};
var $fe485fa379bdff14$export$2e2bcd8739ae039 = (0, $kFqI2.connect)($fe485fa379bdff14$var$mapStateToProps)((0, $7c0ba11073bcb5f1$export$2e2bcd8739ae039));


/**
 * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
 * This ensures we catch and track any errors that occur during the app's initialization,
 * including async operations and React rendering. Moving this call later would risk missing
 * early errors.
 * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
 */ (0, $5QpZa.default)();
const $f5e2aff200456a49$var$sessionDataPromise = (async ()=>{
    (0, $hp2SH.getApolloClient)();
    try {
        const [sessionData] = await Promise.all([
            (0, $aXEzU.getSessionDataAndInitializeStatsig)(),
            (0, $68uaC.Cookies).initialize()
        ]);
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        await (0, $17wUi.initializeStorageManager)({
            userId: userId,
            isLicensed: isLicensed
        });
        (0, $gnYQc.applyPersistedStatsigOverrides)();
        return sessionData;
    } catch  {
        // For the same reasons as in the non-standalone case documented in the
        // counterpart of this file which is
        // confluence/packages/confluence-frontend-server/src/index.js at the moment
        return (0, $iC5L0.getEmptySessionData)();
    }
})();
const $f5e2aff200456a49$var$translationPromise = (0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage));
Promise.all([
    $f5e2aff200456a49$var$sessionDataPromise,
    $f5e2aff200456a49$var$translationPromise
]).then(([sessionData])=>{
    const browserNotSupportedCheck = (0, $2DVQX.coreBrowserNotSupported)();
    // the only requirement for BrowserNotSupported to render is the translationPromise
    if (browserNotSupportedCheck) {
        // the monolith attaches this id to the body here: confluence-core/confluence-webapp/src/main/webapp/decorators/main.vmd:62
        const documentBody = document.getElementById('com-atlassian-confluence');
        // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), documentBody);
    }
    (0, $7LuKf.initialization)(sessionData);
    (0, $8bee1fe38b9eef04$export$ed04e7f6ba662aee)();
    (0, $d4f95b5cede9219f$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6baa9171970034d$export$11eb671888ed6e7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ location: location, matchRoute: matchRoute })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe485fa379bdff14$export$2e2bcd8739ae039), {
            apolloClient: (0, $hp2SH.getApolloClient)(),
            location: location,
            matchRoute: matchRoute
        }))), 'ui-global-sidebar-section', true);
});
 }, ["7EorR","22rRN","iQ5nE","aZinD","eiF7i","hhss7","ffEVr","1yVM6","1qlDN","5pvpJ","6XCf4","4TxwY","6wr18"]);

$parcel$global.rlb("3pblT")
//# sourceMappingURL=standalone-navigation-jquery3.489865e2.js.map
